import { each, event } from "jquery";
import {
  saveJob,
  createAlerts,
  referral,
  recentlyViewedJobs,
  quickJobApplyJobDetails,
  quickAnonUserRegister,
  fetchSimilarJobs,
  getUtmTrackerId,
  branchedQuestionsFetch, getRecommendedJobs,
  searchRecruiters,
  anonJobRfr
} from "../../../../lib/helpers/jobHelpers";
import { logWLAnalyticsEvent } from '../../../../lib/helpers/wlAnalyticsLoggerUtil';
import { LOAD_RECOMMENDED_JOBS_EVENT } from '../../../../lib/helpers/common';

const similarJobTemplate = `
{% for similarJob in similarJobs %}
  <div class="similar-jobs__card">
    <div class="similar-jobs__card__header">
      <div class="similar-jobs__card__header__item">
      </div>

      {% if similarJob.referralIncentive %}
      <span class="similar-jobs__referral-pill">
        {{ similarJob.referralIncentive }} {{ __t('jobSearch.referralBonusLabel') }}
      </span>
      {% endif %}

      <div class="similar-jobs__card__header__item d-flex align-items-center justify-content-center">
        {% if similarJob.score and similarJobsFitScoreConfig and similarJobsFitScoreConfig.enabled %}
          {% set radius = 25 %}
          {% set circumference = 2 * 3.14 * radius %}
          {% set dashoffset = circumference * ((100 - similarJob.score)/100) %}

        <div class="job-match-score {{ 'tooltip-container' if similarJobsFitScoreConfig.fitScoreTooltip }}" style="display: inline; float: right;">
          {% if similarJobsFitScoreConfig.fitScoreTooltip and similarJobsFitScoreConfig.fitScoreTooltipHtml %}
          <div class="tooltip-item">
            {{ similarJobsFitScoreConfig.fitScoreTooltipHtml | safe}}
            <i></i>
          </div>
          {% endif %}
          <svg width="44" height="44" viewBox="-6.25 -6.25 62.5 62.5" version="1.1" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)">
            <circle r="25" cx="25" cy="25" fill="transparent" stroke="#e0e0e0" stroke-width="9"></circle>
            <circle r="25" cx="25" cy="25" fill="transparent" stroke="{{ similarJobsFitScoreConfig.fitScoreColor }}" stroke-width="9" stroke-linecap="round" stroke-dasharray="{{circumference}}" stroke-dashoffset="{{dashoffset}}"></circle>
            <text x="9px" y="26px" fill="#000000" font-size="15px" font-weight="bold" style="transform:rotate(90deg) translate(0px, -46px)">{{similarJob.score}}%</text>
          </svg>
        </div>
        {% endif %}
        <span
          class="similar-jobs__card__header__favorite icon-favorite {{'selected' if similarJob.favorite else 'un-selected' }}"
          style="padding: 0 8px"
          data-jobId="{{ similarJob.jobPostingId }}">
          <svg width="28" height="26" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path class="un-selected" d="M19.16 2.61C18.0983 1.548 16.6908 0.902323 15.1933 0.790378C13.6958 0.678433 12.2078 1.10766 11 2C9.72769 1.05363 8.14402 0.624508 6.56795 0.799034C4.99188 0.97356 3.54047 1.73877 2.506 2.94058C1.47154 4.14239 0.930854 5.69152 0.992833 7.27601C1.05481 8.8605 1.71485 10.3627 2.84003 11.48L10.29 18.93C10.383 19.0237 10.4936 19.0981 10.6155 19.1489C10.7373 19.1997 10.868 19.2258 11 19.2258C11.132 19.2258 11.2627 19.1997 11.3846 19.1489C11.5065 19.0981 11.6171 19.0237 11.71 18.93L19.16 11.48C19.7427 10.8977 20.2049 10.2063 20.5202 9.44536C20.8356 8.68439 20.9979 7.86873 20.9979 7.045C20.9979 6.22127 20.8356 5.40561 20.5202 4.64463C20.2049 3.88365 19.7427 3.19227 19.16 2.61ZM17.75 10.07L11 16.81L4.25003 10.07C3.65521 9.4727 3.25001 8.71304 3.08526 7.88634C2.92052 7.05963 3.00356 6.20268 3.32398 5.42299C3.6444 4.6433 4.18793 3.97559 4.88638 3.50362C5.58483 3.03165 6.40709 2.77644 7.25003 2.77C8.37614 2.77276 9.45513 3.22233 10.25 4.02C10.343 4.11373 10.4536 4.18812 10.5755 4.23889C10.6973 4.28966 10.828 4.3158 10.96 4.3158C11.092 4.3158 11.2227 4.28966 11.3446 4.23889C11.4665 4.18812 11.5771 4.11373 11.67 4.02C12.4884 3.31088 13.5455 2.93914 14.6276 2.98002C15.7096 3.0209 16.7357 3.47134 17.4982 4.24019C18.2607 5.00903 18.7026 6.03884 18.7345 7.12119C18.7664 8.20354 18.3859 9.25759 17.67 10.07H17.75Z" fill="#717688"/>
            <path class="selected" d="M19.8 2.70001C17.7 -0.0999899 13.8 -0.699989 11 1.40001C8.49997 -0.49999 4.99997 -0.19999 2.79997 2.00001C0.399971 4.40001 0.299972 8.40001 2.79997 10.9L8.99997 17.1C9.49997 17.6 10.2 17.9 10.9 17.9C11.6 17.9 12.3 17.6 12.8 17.1L19 10.9C21.4 8.60001 21.6 5.20001 19.8 2.70001Z" fill="#717688"/>
          </svg>
        </span>
      </div>
    </div>
    <p class="similar-jobs__title">
      <a href="{{similarJob.url}}" target="{{linkTarget}}">{{ similarJob.jobPostingName }}</a>
    </p>
    {% if similarJob.location and similarJob.displaylocation %}
      <div class="similar-jobs__infos">
        <div class="similar-jobs__info">
          <svg width="16" height="20" viewBox="0 0 16 20" fill="#333C59" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 13.4 7.05 19.5 7.35 19.76C7.53113 19.9149 7.76165 20.0001 8 20.0001C8.23835 20.0001 8.46887 19.9149 8.65 19.76C9 19.5 16 13.4 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 17.65C5.87 15.65 2 11.34 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8C14 11.34 10.13 15.66 8 17.65ZM8 4C7.20887 4 6.43552 4.2346 5.77772 4.67412C5.11992 5.11365 4.60723 5.73836 4.30448 6.46927C4.00173 7.20017 3.92252 8.00444 4.07686 8.78036C4.2312 9.55628 4.61216 10.269 5.17157 10.8284C5.73098 11.3878 6.44371 11.7688 7.21964 11.9231C7.99556 12.0775 8.79983 11.9983 9.53073 11.6955C10.2616 11.3928 10.8864 10.8801 11.3259 10.2223C11.7654 9.56448 12 8.79113 12 8C12 6.93913 11.5786 5.92172 10.8284 5.17157C10.0783 4.42143 9.06087 4 8 4ZM8 10C7.60444 10 7.21776 9.8827 6.88886 9.66294C6.55996 9.44318 6.30362 9.13082 6.15224 8.76537C6.00087 8.39991 5.96126 7.99778 6.03843 7.60982C6.1156 7.22186 6.30608 6.86549 6.58579 6.58579C6.86549 6.30608 7.22186 6.1156 7.60982 6.03843C7.99778 5.96126 8.39991 6.00087 8.76537 6.15224C9.13082 6.30362 9.44318 6.55996 9.66294 6.88886C9.8827 7.21776 10 7.60444 10 8C10 8.53043 9.78929 9.03914 9.41421 9.41421C9.03914 9.78929 8.53043 10 8 10Z" fill="#333C59"/>
          </svg>
          <span class="similar-jobs__info-text">
            <div class="location-wrapper">
            {{ similarJob.location }}
             {% if otherLocales(similarJob).length > 0 %}
            <span class="other-count">
              +{{ otherLocales(similarJob).length }}

              <div class="multi-locale-tooltip-box">
                {% for locale in otherLocales(similarJob) %}
                  <div class="multi-locale-text-color">{{ locale }}</div>
                {% endfor %}
              </div>
            </span>
          {% endif %}
            </div>
            
          </span>
        </div>
      </div>
    {% endif %}
  </div>
{% endfor %}`

export default () => {
  apos.util.widgetPlayers.jobDetails = {
    selector: ".job-page-content",
    player: async function (jobDetails) {
      const __t = JSON.parse(jobDetails.dataset.localizedValues);
      const recommendedJobsContainer = jobDetails.querySelector('#recommended-jobs-container');
      const recommendedJobsOptions = {
        enabled: Boolean(recommendedJobsContainer),
        minScore: recommendedJobsContainer && recommendedJobsContainer.dataset.minScore,
        limit: recommendedJobsContainer && recommendedJobsContainer.dataset.limit
      };

      var shareURL = null;
      var triggerMethod = null;
      var shareLink = null;
      var shareCMSLink = null;
      var oldEmail=null;
      var jobtitle = null;
      var QuestionnaireValidated=true
      var jobDetailsTab = document.querySelectorAll(".jobDetailsTab");
      var applicationTab = document.querySelector(".applicationTab");
      var clickBtn = document.getElementById("redirect");
      var clickBtn2 = document.getElementById("redirectBtn");
      var sidePanel = document.querySelector(".side-panel");
      var nextButton = document.querySelector('#quickapply-next');
      var previousButton = document.querySelector('#quickapply-back')
      var userId=0;
      var templateId =0
      var nonBranchedQuestionTemplateId =0
      var hasPreviousButton="false"
      var hasNextButton="false"
      var hasAnsweredAll=false
      var isBranchedQuestionnaire =false;
      var isCurrentQuestionnairePageAnswered =false;
      var jobPostingCompanyId =0;
      var phoneInput = null;
      var phoneInputQuickApply = null;
      var similarJobLocation = false
      var similarJobContractType = false
      var externalUrl = window.aposCustomConfig?.baseUrl;
      const resumeField = jobDetails.querySelector('#quickapply-resume');
      const resumeFieldLabel = jobDetails.querySelector('#quickapply-resume-label');
      const companyData = jobDetails.querySelector('#job-referal-data')?.dataset;
      const apiData = document.getElementById("api-data").dataset;
      const config = {
          initialCountry: apiData?.phonedefaultcountry || 'us',
      }
      if (apiData.countrycodephonenumber) {
          const countries = JSON.parse(
            apiData.countrycodephonenumber
          ).map(c => c.toLowerCase())
          if (countries.length > 0) {
            config.onlyCountries = countries
          }
      }
      if (resumeField && resumeFieldLabel) {
        resumeField.addEventListener('change', () => {
          if (resumeField.files.length > 0) {
            resumeFieldLabel.innerHTML = `<span>${resumeField.files[0].name}</span>`;
          }
        });
      }

      var similarJobDiv = document.getElementsByClassName("similar-jobs");
      let utmTrackerId = null;
      if (similarJobDiv && similarJobDiv.length) {
        const apiData = document.getElementById("api-data").dataset;
        const jobData = document.getElementById("job-data").dataset;
        const globalData = document.getElementById("global-data").dataset
        const similarJobDataAttributes = document.getElementById('similarJobAttributes').dataset
        const companyCode = apiData['companycode'];
        const baseUrl = apiData['baseurl'];
        const jobId = jobData["jobid"];
        const linkTarget = globalData["linktarget"]
        const locationFormat = jobData["locationformat"]
        const similarJobAttributes = similarJobDataAttributes["similarJobAttributes"]
        if(similarJobAttributes !=null){
        var attr = similarJobAttributes.split(",");
        if(attr.includes('location')){
          similarJobLocation = true
        }
      }
        const element = document.getElementsByClassName("similar-jobs__cards")[0]
        fetch(`${baseUrl}/document-matching-svc/webhooks/get_matching_jobs?jobId=${jobId}&companyCode=${companyCode}`)
          .then(response => response.json())
          .then((data) => {
            const savedJobs = JSON.parse(apos.util.getCookie('workllama-saved-jobs') || '[]').map(job => Number(job.id));
            let similarJobs = data.data?.similarJobs || []
            if (!similarJobs.length) {
              element.innerHTML = `<div class="similar-jobs__card">${__t['jobDetail.noSimilarFoundMessage']}</div>`;
              return
            }
            const recommendedJobs = getRecommendedJobs();

            similarJobs.forEach((job) => {
              job.location = locationText(job.facility, locationFormat)
              let url = `${job.jobPostingName} in ${job.location} ${job.jobPostingId}`.replace(/[.,\/#!$%\^&\*;:{}=\-–_`~()]/g, " ").replace(/\s\s+/g, " ").replace(/ /g, "-");
              const recommendedJob = recommendedJobs.find(rJob => rJob.id === job.jobPostingId);
              url = `/job/${url}`
              job.url = url
              job.favorite = savedJobs.includes(job.jobPostingId) ? true : false
              job.score = recommendedJob ? recommendedJob.score : null;
              job.displaylocation = similarJobLocation
            }
          )
            const similarJobsFitScoreElement = jobDetails.querySelector('.similar-jobs-fit-score-data');
            const similarJobsFitScoreConfig = {};

            if (similarJobsFitScoreElement) {
              similarJobsFitScoreConfig.enabled = true;
              similarJobsFitScoreConfig.fitScoreColor = similarJobsFitScoreElement.dataset.fitScoreColor;
              similarJobsFitScoreConfig.fitScoreTooltip = similarJobsFitScoreElement.dataset.fitScoreTooltip === 'true';
              similarJobsFitScoreConfig.fitScoreTooltipHtml = similarJobsFitScoreElement.innerHTML;
            }

            function otherLocales(job){
              const additionalFacility = job?.additional_facility;
              if(!additionalFacility || additionalFacility === "null"){
                return [];
              }
              const additionalFacilities = JSON.parse(additionalFacility);
              if (!Array.isArray(parsed)) {
                return [];
              }
              const facilityNames = additionalFacilities.map( facility => {
              return facility.name.trim();
            }).filter(name => name);
            return facilityNames;

            }

            const compiedtemplae = nunjucks.renderString(similarJobTemplate, { similarJobs, linkTarget, similarJobsFitScoreConfig, otherLocales });
            element.innerHTML +=  compiedtemplae

            const saveIcons = element.querySelectorAll('.icon-favorite');
            saveJob(saveIcons);
          });
      }

      if (jobDetails) {
        addFavoriteListener();

        const containsUtmParams = window.location.search.includes('utm_source') || window.sessionStorage.getItem('utm_source');

        if (containsUtmParams) {
          getUtmTrackerId('Job')
            .then(response => {
              utmTrackerId = response;
            });
        }
      }

      function addFavoriteListener() {
        const saveIcons = jobDetails.querySelectorAll(".btn-favorite");
        saveJob(saveIcons);
      }

      function locationText(facility, locationFormat) {
        if (locationFormat) {
          let {city, state, country, name} = facility;
          city = city && city.trim()
          state = state && state.trim()
          country = country && country.trim()
          name = name && name.trim()
          if (city && state) {
            return locationFormat
              .replace('{$.Facility.City}', city)
              .replace('{$.Facility.State}', state)
              .replace('{$.Facility.Country}', country)
              .replace('{$.Facility.Name}', name);
          } else if (state && country) {
            return state+","+country
          } else if (country){
            return country
          }
        } else {
          return facility.name
        }
      }
      function deselectText() {
        var inputField = document.getElementById('firstName');
        inputField.focus(); // Focus on the input field
        inputField.setSelectionRange(0, 0); // Set the selection range to the beginning (0) or end (inputField.value.length) of the text
      }
      function updateSidePanelVisibility(tabName) {
        if (tabName === "job") {
          sidePanel.classList.remove("hide-for-application");
        } else if (tabName === "app") {
          sidePanel.classList.add("hide-for-application");
        }
      }

      function showTabContent(tabName) {
        var jobDetailsPage = document.getElementsByClassName("jobDetailsPage");
        var quickApplyPage = document.getElementsByClassName("quickApplyPage");

        if (tabName === "job") {
          for (var j = 0; j < jobDetailsPage.length; j++) {
            jobDetailsPage[j].style.display = "block";
          }
          for (var i = 0; i < quickApplyPage.length; i++) {
            quickApplyPage[i].style.display = "none";
          }
        } else if (tabName === "app") {
          for (var i = 0; i < jobDetailsPage.length; i++) {
            jobDetailsPage[i].style.display = "none";
          }
          for (var i = 0; i < quickApplyPage.length; i++) {
            quickApplyPage[i].style.display = "block";
          }
        }
      }

      if (jobDetailsTab.length > 0) {
        for (var i = 0; i < jobDetailsTab.length; i++) {
          jobDetailsTab[i].addEventListener(
            "click",
            function (evt, pageName = "jobDetails") {
              var tabName = evt.currentTarget.getAttribute("data-tab");
              updateSidePanelVisibility(tabName);
              showTabContent(tabName);

              for (var k = 0; k < jobDetailsTab.length; k++) {
                jobDetailsTab[k].classList.remove("active");
              }
              if (applicationTab) {
                applicationTab.classList.remove("active");
              }
              // document.getElementById(pageName).style.display = "block";
              evt.currentTarget.classList.add("active");
            }
          );
        }
      }

      if (applicationTab) {
        applicationTab.addEventListener(
          "click",
          function (evt, pageName = "application") {
            var tabName = evt.currentTarget.getAttribute("data-tab");
            updateSidePanelVisibility(tabName);
            showTabContent(tabName);

            for (var j = 0; j < jobDetailsTab.length; j++) {
              jobDetailsTab[j].classList.remove("active");
            }
            if (applicationTab) {
              applicationTab.classList.remove("active");
            }
            // document.getElementById(pageName).style.display = "block";
            evt.currentTarget.classList.add("active");
             window.loadRecaptcha && window.loadRecaptcha("#quickResumeApplyDetails");

            // Track Click on Apply Now Button
            var jobData = document.querySelector("#job-data");
            logWLAnalyticsEvent("Job Apply Selected", {
              jobTitle: jobData?.dataset?.jobtitle,
              jobPostingId: jobData?.dataset?.jobid,
            });
            setupQuickApplyPhoneInput();
          }
        );
      }

      if (clickBtn) {
        clickBtn.addEventListener(
          "click",
          function (evt, pageName = "application") {
            var tabName = evt.currentTarget.getAttribute("data-tab");
            updateSidePanelVisibility(tabName);
            var jobDetailsPage =
              document.getElementsByClassName("jobDetailsPage");
            for (var i = 0; i < jobDetailsPage.length; i++) {
              jobDetailsPage[i].style.display = "none";
            }
            var quickApplyPage =
              document.getElementsByClassName("quickApplyPage");
            for (var i = 0; i < quickApplyPage.length; i++) {
              quickApplyPage[i].style.display = "block";
            }
            for (var j = 0; j < jobDetailsTab.length; j++) {
              jobDetailsTab[j].classList.remove("active");
            }
            if (applicationTab) {
              applicationTab.classList.add("active");
            }
            document.getElementById(pageName).style.display = "block";
            evt.currentTarget.classList.add("active");
            window.loadRecaptcha && window.loadRecaptcha("#quickResumeApplyDetails");

            // Track Click on Apply Now Button
            var jobData = document.querySelector("#job-data");
            logWLAnalyticsEvent("Job Apply Selected", {
              jobTitle: jobData?.dataset?.jobtitle,
              jobPostingId: jobData?.dataset?.jobid,
            });
            setupQuickApplyPhoneInput();
          }
        );
      }

      if (clickBtn2) {
        clickBtn2.addEventListener(
          "click",
          function (evt, pageName = "application") {
            var tabName = evt.currentTarget.getAttribute("data-tab");
            updateSidePanelVisibility(tabName);
            var jobDetailsPage =
              document.getElementsByClassName("jobDetailsPage");
            for (var i = 0; i < jobDetailsPage.length; i++) {
              jobDetailsPage[i].style.display = "none";
            }
            var quickApplyPage =
              document.getElementsByClassName("quickApplyPage");
            for (var i = 0; i < quickApplyPage.length; i++) {
              quickApplyPage[i].style.display = "block";
            }
            for (var j = 0; j < jobDetailsTab.length; j++) {
              jobDetailsTab[j].classList.remove("active");
            }
            if (applicationTab) {
              applicationTab.classList.add("active");
            }
            document.getElementById(pageName).style.display = "block";
            evt.currentTarget.classList.add("active");
            window.loadRecaptcha && window.loadRecaptcha("#quickResumeApplyDetails");
            // Track Click on Apply Now Button
            var jobData = document.querySelector("#job-data");
            logWLAnalyticsEvent("Job Apply Selected", {
              jobTitle: jobData?.dataset?.jobtitle,
              jobPostingId: jobData?.dataset?.jobid,
            });
            setupQuickApplyPhoneInput();
          }
        );
      }
      // ###########################################################################

      var mode = null;

      const jobErrorSection = document.getElementById("job-error");
      if (jobErrorSection) {
        const jobId = jobErrorSection.dataset["jobid"];
        if (!jobId) {
          window.setTimeout(() => {
            document.location.href = "/";
          }, 5000);
          return;
        }
      }
      if (jobDetails) {
        const job = document.getElementById("job-data").dataset;
        const data = document.getElementById("api-data").dataset;
        const id = job["jobid"];
        const jobTitle = data["jobtitle"];
        
        // Track Click on job Event
        logWLAnalyticsEvent("Job Details Viewed", {
          jobPostingId: id,
          jobTitle: jobTitle,
        });

        recentlyViewedJobs(id);
      }
      const jobShare = jobDetails.querySelector("#job-Share");
      if (jobShare) {
        var data = jobShare.dataset;
        shareLink = data["link"];
        var url = window.location.href.split("?");
        shareCMSLink =
          url[0] ;

        const data2 = document.getElementById("api-data").dataset;
        jobtitle = data2["jobtitle"];
        mode = data["sharemode"];
      }

      const faceBook = document.querySelector(".faceBook");
      if (faceBook) {
        faceBook.addEventListener("click", onShareLink);
        async function onShareLink() {
          if (mode == "true" && shareURL == null) {
            triggerMethod = ".faceBook";
            var overlay = document.querySelector("#hide-overlay");
            overlay.style.display = "initial";
            setupReferPhoneInput();
          } else if (mode == "false") {
            logWLAnalyticsEventForJobShare(`https://www.facebook.com/sharer/sharer.php?u=${shareCMSLink}`);
            window.open(
              "https://www.facebook.com/sharer/sharer.php?u=" +
               encodeURIComponent(shareCMSLink +"?utm_source=fb_share&utm_campaign=cms&utm_medium=referral")+
                "",
              "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            );
          } else {
            logWLAnalyticsEventForJobShare(`https://www.facebook.com/sharer/sharer.php?u=${shareURL}`);
            window.open(
              "https://www.facebook.com/sharer/sharer.php?u="+ encodeURIComponent(shareURL +"?utm_source=fb_share&utm_campaign=cms&utm_medium=referral") +  "",
              "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            );
          }
        }
      }
        async function appendLoginUrl() {
          var userExistsLink = document.querySelector('#userExists')
      let existingHref = userExistsLink.getAttribute('href');
      var params=window.location.href.split('?')
        if(params.length>1 &&(params[1].includes('utm_campaign')||params[1].includes('utm_source')||params[1].includes('utm_medium'))){
          let existingHref = userExistsLink.getAttribute('href');
          existingHref += '?' +params[1];
          userExistsLink.setAttribute('href', existingHref);
        }

        }

      const linkedIn = document.querySelector(".linkedIn");
      if (linkedIn) {
        linkedIn.addEventListener("click", onShareLink);
        async function onShareLink() {
          if (mode == "true" && shareURL == null) {
            triggerMethod = ".linkedIn";
            var overlay = document.querySelector("#hide-overlay");
            overlay.style.display = "initial";
            setupReferPhoneInput();
          } else if (mode == "false") {
            logWLAnalyticsEventForJobShare(`https://www.linkedin.com/shareArticle?mini=true&url=${shareCMSLink}`);
            window.open(
              "https://www.linkedin.com/shareArticle?mini=true&url=" +
              encodeURIComponent(shareCMSLink +"?utm_source=linkedin_share&utm_campaign=cms&utm_medium=referral") +
                "&title=",
              "",
              "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            );
          } else {
            logWLAnalyticsEventForJobShare(`https://www.linkedin.com/shareArticle?mini=true&url=${shareURL}`);
            window.open(
              "https://www.linkedin.com/shareArticle?mini=true&url=" +
              encodeURIComponent( shareURL+"?utm_source=linkedin_share&utm_campaign=cms&utm_medium=referral") +
                "&title=",
              "",
              "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            );
          }
        }
      }
      const twitter = document.querySelector(".twitter");
      if (twitter) {
        twitter.addEventListener("click", onShareLink);
        async function onShareLink() {
          if (mode == "true" && shareURL == null) {
            triggerMethod = ".twitter";
            var overlay = document.querySelector("#hide-overlay");
            overlay.style.display = "initial";
            setupReferPhoneInput();
          } else if (mode == "false") {
            logWLAnalyticsEventForJobShare(`https://twitter.com/share?url=${shareCMSLink}`);
            window.open(
             "https://twitter.com/share?url=" + encodeURIComponent( shareCMSLink +"?utm_source=x_share&utm_campaign=cms&utm_medium=referral")+ "",
              "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            );
          } else {
            logWLAnalyticsEventForJobShare(`https://twitter.com/share?url=${shareURL}`);
            window.open(
              "https://twitter.com/share?url=" + encodeURIComponent(shareURL +"?utm_source=x_share&utm_campaign=cms&utm_medium=referral")+ "",
              "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            );
          }
        }
      }
        var currentEmail = document.querySelector("#emailInput");
        if(currentEmail){
        currentEmail.addEventListener("input", emailChanged);
        function emailChanged(){
          var isExistingEmailEnable= jobDetails.querySelector(
            "#quick-apply-existing-user"
          )
          if(isExistingEmailEnable.style.display=='block' && oldEmail!=null &&oldEmail != currentEmail.value && currentEmail.value.length>0){
            var newcheck= validateEmail(currentEmail.value)

            if(newcheck){
              isExistingEmailEnable.style.display="none"
              oldEmail=null

            }
          }
        }
      }


      const email = document.querySelector(".email");
      if (email) {
        email.addEventListener("click", onShareLink);
        async function onShareLink() {
          if (mode == "true" && shareURL == null) {
            triggerMethod = ".email";
            var overlay = document.querySelector("#hide-overlay");
            overlay.style.display = "initial";
            setupReferPhoneInput();
          } else if (mode == "false") {
            var emailSub = __t['jobDetail.shareLinkEmailSubject'] + jobtitle;
            var emailBody = __t['jobDetail.shareLinkEmailBody'].replace('{shareLink}', shareCMSLink+"?utm_source=email_share&utm_campaign=cms&utm_medium=referral");
            logWLAnalyticsEventForJobShare(`${shareCMSLink}`);
            window.open(
              "mailto:?" +
                "&subject=" +
                encodeURIComponent(emailSub) +
                "&body=" +
                encodeURIComponent(emailBody)
            );
          } else {
            var emailSub = __t['jobDetail.shareLinkEmailSubject'] + jobtitle;
            var emailBody = __t['jobDetail.shareLinkEmailBody'].replace('{shareLink}',shareURL+"?utm_source=email_share&utm_campaign=cms&utm_medium=referral");
            logWLAnalyticsEventForJobShare(`${shareURL}`);
            window.open(
              "mailto:?" +
                "&subject=" +
                encodeURIComponent(emailSub) +
                "&body=" +
                encodeURIComponent(emailBody)
            );
          }
        }
      }

      const copyLink = document.querySelector(".copyToClipBoard");
      if (copyLink) {
        copyLink.addEventListener("click", onShareLink);
        async function onShareLink() {
          if (mode == "true" && shareURL == null) {
            triggerMethod = ".copyToClipBoard";
            var overlay = document.querySelector("#hide-overlay");
            overlay.style.display = "initial";
            setupReferPhoneInput();
          } else if (mode == "false") {
            logWLAnalyticsEventForJobShare(`${shareCMSLink}`);
            navigator.clipboard.writeText(shareCMSLink+"?utm_source=workllama_share&utm_campaign=cms&utm_medium=referral")
           .then(() => {
              alert(__t['jobDetail.copiedToClipboardMessage']);
            });
          } else {
            logWLAnalyticsEventForJobShare(`${shareURL}`);
            navigator.clipboard.writeText(shareURL+"?utm_source=workllama_share&utm_campaign=cms&utm_medium=referral")
           .then(() => {
              alert(__t['jobDetail.copiedToClipboardMessage']);
            });
          }
        }
      }

      const close = document.querySelector("#close");
      if (close) {
        close.addEventListener("click", onClose);
        async function onClose() {
          var overlay = document.querySelector("#hide-overlay");
          overlay.style.display = "none";
        }
      }

      function setupReferPhoneInput() {
        var resumeSubmitCompany = document.getElementById("referForm").dataset;
        var phoneInputField = document.querySelector("#phoneSubmit");
        phoneInput = window.intlTelInput(phoneInputField,config);
      }

      

      function setupQuickApplyPhoneInput() {
        const companyData = jobDetails.querySelector("#quickResumeApplyDetails").dataset;
        nonBranchedQuestionTemplateId = companyData['questiontemplateid']
        var phoneInputFieldQuickApply = document.querySelector("#phone");
        var phoneInputField = document.querySelector("#phone");
        phoneInputQuickApply = window.intlTelInput(
          phoneInputFieldQuickApply,
          config
        );

      }

      // Track Click on Job Share
      function logWLAnalyticsEventForJobShare(url) {
        var jobData = document.querySelector("#job-data");
        logWLAnalyticsEvent("Job Shared", {
          jobTitle: jobData?.dataset?.jobtitle,
          jobPostingId: jobData?.dataset?.jobid,
          shareUrl: url,
          referralType: 'Job referral',
          loggedIn: false,
        });
      }

      const jobAlertsButton = jobDetails.querySelector("#job-alerts-button");
      if (jobAlertsButton) {
        jobAlertsButton.addEventListener("click", onJobAlertsSubmit);

        /**
         * To-Do: refactor into lib module
         * @returns
         */
        async function onJobAlertsSubmit() {
          const jobAlertsEmailInput = document.querySelector(
            "#job-alerts-email-input"
          );
          const termsAndConditions = jobDetails.querySelector("#terms");
          const termsAndConditions2 = jobDetails.querySelector("#terms2");
          const termsAndConditions3 = jobDetails.querySelector("#terms3");
          // const jobalertSmOptIn = jobDetails.querySelector("#jobalertSmOptIn");
          const jobAlertName = jobDetails.querySelector(
            "#job-alerts-name-input"
          );
          const jobAlertFrequency = document.getElementsByName(
            "job-alert-frequency"
          );
          var frequency = document.querySelector(
            'input[name="job-alert-frequency"]:checked'
          )?.value;
          if (jobAlertName?.value.length < 3) {
            displayValidationMessage(
              jobAlertName,
              __t['jobAlert.nameErrorInvalid']
            );
            // window.alert('Please enter a valid alert name.');
            return null;
          } else if (
            !(
              jobAlertsEmailInput &&
              jobAlertsEmailInput?.value &&
              validateEmail(jobAlertsEmailInput?.value)
            )
          ) {
            displayValidationMessage(
              jobAlertsEmailInput,
              __t['global.emailErrorInvalid']
            );
            return null;
          } else if ( termsAndConditions && !termsAndConditions.checked) {
            displayValidationMessage(
              termsAndConditions,
              __t['jobAlert.termsServiceErrorRequired']
            );
            return null;
          }
          else if (termsAndConditions2 && !termsAndConditions2.checked ) {
            displayValidationMessage(
              termsAndConditions2,
              __t['jobAlert.termsServiceErrorRequired']
            );
            return null;
          }
          else if (termsAndConditions3 && !termsAndConditions3.checked ) {
            displayValidationMessage(
              termsAndConditions3,
              __t['jobAlert.termsServiceErrorRequired']
            );
            return null;
          }
          else {
            const title = document.getElementById("job-title").innerHTML;
            const data = document.getElementById("job-data").dataset;
            const latitude = data["latitude"];
            const longitude = data["longitude"];
            const locShortName = data["locshortname"];
            const data2 = document.getElementById("api-data").dataset;
            const jobtitle = data2["jobtitle"];
            var jobAlertConfigDetails = [
              {
                name: "JobPosting.searchField",
                label: "Job Title, Description or Company",
                displayType: "text",
                fieldType: 1,
                value: jobtitle,
              },
            ];
            var locationInfo = {
              latLong: { latitude: latitude, longitude: longitude },
              locationType: "",
              locShortName: locShortName,
              radius: "50",
            };
            var sortCriteria = { sortField: "", sortOrderAsc: false };

            // var notificationType = {email: true, sms: false, push: false}
            // if(jobalertSmOptIn){
            //   notificationType = {email: true, sms: jobalertSmOptIn.checked, push: false}
            // }
            const response = await createAlerts({
              email: jobAlertsEmailInput?.value,
              name: jobAlertName?.value,
              jobAlertFrequency: frequency,
              jobAlertConfigDetails: {
                jobParamRequests: jobAlertConfigDetails,
                locationInfo: locationInfo,
                sortCriteria: sortCriteria,
                text: "",
              }
              // notificationType: notificationType
            });
            if (!response.success) {
              if (
                response.errorMessage ==
                "You already have an account. Please log in to create a job alert."
              ) {
                jobDetails.querySelector(
                  "#show-login-error-message"
                ).style.display = "block";
              } else {
                jobDetails.querySelector("#show-error-message").innerHTML =
                  __t['jobAlert.existingAccountError'];
              }
              return null;
            }

            // Track Job Alert Creation
            logWLAnalyticsEvent('Job Alert Created', {
              jobAlertId: response.jobAlertId,
              jobAlertName: jobAlertName?.value,
              jobAlertFrequency : frequency,
              loggedIn: false,
            });

            const jobAlertsEmail = document.querySelector("#job-alerts-email");
            if (jobAlertsEmail) {
              jobAlertsEmail.innerHTML = jobAlertsEmailInput?.value;
            }
            const jobAlertsForm = document.querySelector(
              ".job-alerts__card.form"
            );
            const jobAlertsSuccess = document.querySelector(
              ".job-alerts__card.hidden"
            );
            if (jobAlertsForm) jobAlertsForm.classList.add("hidden");
            if (jobAlertsSuccess) jobAlertsSuccess.classList.remove("hidden");
          }
        }
      }
      const submitButton = document.querySelector("#refer-submit");

      if (submitButton) {
        submitButton.addEventListener("click", onSubmitButtonClick);
        async function onSubmitButtonClick() {
          const companyData = jobDetails.querySelector("#job-Share").dataset;
          const data = document.getElementById("job-data").dataset;
          const jobId = data["jobid"];
          const data2 = document.getElementById("api-data").dataset;
          const companyCode = data2["companycode"];

          var inputPhone = null;

          const name = document.querySelector("#fullName");
          const email = document.querySelector("#emailPhone");
          const phone = document.querySelector("#phoneSubmit");
          inputPhone = phoneInput.getNumber(
            intlTelInputUtils.numberFormat.E164
          );

          var isValid = validate(name, email, inputPhone, phone);

          if (isValid) {
            const userData = {
              companyCode: companyCode,
              jobPostingId: jobId,
              email: email?.value,
              phoneNbr: inputPhone,
              referralCode: "",
              referredJobLocation: "",
              userFullName: name?.value,
            };
            var response = await referral(userData);
            if ((response.success = true)) {
              shareURL = response.referralUrl;
              // shareLink.setAttribute('data-url', shareURL);
              var overlay = document.querySelector("#hide-overlay");
              overlay.style.display = "none";

              jobDetails.querySelector(triggerMethod).click();
            } else {
              alert(response.errorMessage);
              name.value = "";
              emailPhone.value = "";
            }
          }
        }
      }

      function validate(name, email, phone, phoneText) {
        if (!validateName(name)) {
          return false;
        }
        if (email?.value.length == 0 || !validateEmail(email?.value)) {
          displayValidationMessage(email, __t['jobAlert.emailErrorInvalid']);
          return false;
        }
        if (!phoneInput.isValidNumber()) {
          displayValidationMessage(
            phoneText,
            __t['quickApply.phoneErrorInvalid']
          );
          return false;
        }
        return true;
      }
      function validateName(name) {
        if (name?.value.length < 4) {
          displayValidationMessage(
            name,
            __t['jobAlert.nameErrorMinLength']
          );
          return false;
        }
        return true;
      }
      function validateEmail(email) {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      }
      function validateNumber(phone) {
        if (!isNaN(phone) && phone.length == 10) {
          return true;
        } else {
          false;
        }
      }

      const referalDescription = jobDetails.querySelector(
        ".job-detail__refer-description"
      );
      const referalDescriptionIcon = jobDetails.querySelector(
        "#referal-description-open"
      );
      if (referalDescription && referalDescriptionIcon) {
        const descriptionCloseIcon = referalDescription.querySelector(
          "#referal-description-close"
        );
        referalDescriptionIcon.addEventListener("click", () =>
          referalDescription.classList.toggle("expand")
        );
        descriptionCloseIcon.addEventListener("click", () =>
          referalDescription.classList.toggle("expand")
        );
      }
      
      // Job referral logic starts here
      // const companyData = jobDetails.querySelector('#job-referal-data')?.dataset;
      const yourPhone = jobDetails.querySelector("#yourPhone");
      if (yourPhone) {
        yourPhone.addEventListener("input", () => {
          console.log("inside your phone")
            const currentInputValue = yourPhone?.value;
            const formattedPhoneNumber = formatPhoneNumber(currentInputValue);
            yourPhone.value = formattedPhoneNumber;
        });
      }
    
      const friendphoneNumberField = jobDetails.querySelector("#friendPhone");
      if(friendphoneNumberField){
          friendphoneNumberField.addEventListener("input", () => {
            const currentInputValue = friendphoneNumberField?.value;
            const formattedPhoneNumber = formatPhoneNumber(currentInputValue);
            friendphoneNumberField.value = formattedPhoneNumber;
        });
      }

      let yourPhoneInput, friendPhoneInput;
      if(friendphoneNumberField){
        friendPhoneInput = window.intlTelInput(friendphoneNumberField,config);
      }
    
      const defaultCountry = companyData?.phonedefaultcountry || 'us'; // fallback to 'us' or any default

      if(yourPhone){
        yourPhoneInput = window.intlTelInput(yourPhone,config);
      }
   
      
      const referalBtn = jobDetails.querySelector("#job-referal-button");
      const referralForm = jobDetails.querySelector(".job-detail__job-referal-form");
      if(referalBtn && referralForm){
        const jobReferralCloseIcon = referralForm.querySelector("#job-referraal-form-close");
        referalBtn.addEventListener("click", () =>
          referralForm.classList.toggle("expand")
        );
      jobReferralCloseIcon.addEventListener("click", () => {
        resetReferralForm();
        referralForm.classList.toggle("expand");
      });
      }
      const jobRfrCancelBtn = jobDetails.querySelector('#cancelBtn');
      if(jobRfrCancelBtn){
        jobRfrCancelBtn.addEventListener("click", () => {
        resetReferralForm();
        referralForm.classList.toggle("expand");
        });
      }
      const jobReferalSubmit = jobDetails.querySelector("#job-referral-submit");
    
      const resumeUpload = jobDetails.querySelector("#resumeUpload");
      const resumePreview = jobDetails.querySelector("#resumePreview");
      const resumeFileName =jobDetails.querySelector("#resumeFileName");
      const resumeFileSize = jobDetails.querySelector("#resumeFileSize");
      const removeResume = jobDetails.querySelector("#removeResume");
      const resumeUploadArea = jobDetails.querySelector("#uploadArea");
      const jobresumeField = jobDetails.querySelector('#resumeUpload');

      if(resumeUpload){
      resumeUpload.addEventListener("change", function () {
        if (resumeUpload.files.length > 0) {
          const file = resumeUpload.files[0];
          resumeFileName.textContent = file.name;
          resumeFileSize.textContent = (file.size / 1024).toFixed(1) + " KB";
          resumeUploadArea.classList.add("d-none")
          resumePreview.classList.remove("d-none");
          clearValidationMessage(jobresumeField, resumePreview);
        }
      });
    }

      // Remove file
      if(removeResume){
        removeResume.addEventListener("click", function () {
          resumeUpload.value = ""; 
          resumeError.classList.add("d-none");
          resumePreview.classList.add("d-none");
          resumeUploadArea.classList.remove("d-none")
        });
      }
        
      const recruiterSearch = jobDetails.querySelector('#recruiter-filters-collapse');
      if(recruiterSearch) {
          const inputField = recruiterSearch.querySelector('input[type=text]');
          inputField.addEventListener('keyup', async () => {
          console.log("recruiter seach.....")
          const recruiterSearch = jobDetails.querySelector('#recruiter-filters-collapse');
          const inputField = recruiterSearch.querySelector('input[type=text]');

          const recruiterEmailSelect = recruiterSearch.querySelector('#recruiterEmail');
          const recruiterNameSelect = recruiterSearch.querySelector('#recruiterName');
          const selectField = recruiterSearch.querySelector('select');
          const filterSlugAlias = selectField.getAttribute('data-filterslugalias');
          const filterName = selectField.getAttribute('data-filtername');
          const fieldType = selectField.getAttribute('data-fieldtype');
          const displayType = selectField.getAttribute('data-displaytype');
          if(inputField.value && inputField.value.length >= 3) {
            const recruiters = await searchRecruiters(inputField.value);
            if(recruiters && recruiters.recruiterList) {
                const values = recruiters.recruiterList.map((x) => {
                return {display: x.recruiterName, value: x.recruiterEmail, extraValue: x.recruiterId}
            });
              addDropDown(recruiterSearch.parentNode, inputField, values, filterSlugAlias, filterName, fieldType, displayType, selectField);
                // recruiterNameSelect.innerHTML = "";
                // recruiters.recruiterList.forEach((x) => {
                //   const option = document.createElement("option");
                //   option.value = x.recruiterName;
                //   option.textContent = x.recruiterName;
                //   recruiterNameSelect.appendChild(option);
                // });
            }
            else
              addDropDown(recruiterSearch.parentNode, inputField, [], filterSlugAlias, filterName, fieldType, displayType, selectField);
              // recruiterNameSelect.innerHTML = "";
            }
          });
      }

      if(jobReferalSubmit){
        var friendPhone = '', myPhone = '';
        jobReferalSubmit.addEventListener('click',async ()=>{
           var friendResumeFile = null;
           const formContainer = document.getElementById("job-referal-data");
            var overlay = document.querySelector("#job-refer-overlay");
            var spinner = document.querySelector('#job-refer-spinner');
            const errorMsg = document.getElementById("job-refer-error");
             const postSubmit =jobDetails.querySelector('#job-refer-post-submit-sucess')
          try{
            const data = document.getElementById("api-data").dataset;
            const companyCode = data["companycode"];
            const myFirstNameField = jobDetails.querySelector('#yourFirstName');
            const myLastNameField = jobDetails.querySelector('#yourLastName');
            const myEmailField = jobDetails.querySelector('#yourEmail');
            const myPhoneNumberField = jobDetails.querySelector('#yourPhone');
            myPhone = yourPhoneInput.getNumber();
            const myPhoneNational = yourPhoneInput.getNumber();
            const myCountryData = yourPhoneInput.getSelectedCountry();
            const myCountryCode = myCountryData.dialCode;

            const firstNameField = jobDetails.querySelector('#friendFirstName');
            const lastNameField = jobDetails.querySelector('#friendLastName');
            const emailField = jobDetails.querySelector('#friendEmail');
            const phoneNumberField = jobDetails.querySelector('#friendPhone');
            friendPhone = friendPhoneInput.getNumber();
            const friendPhoneNational = yourPhoneInput.getNumber()
            const frdCountryData = friendPhoneInput.getSelectedCountry();
            const frdCountryCode = frdCountryData.dialCode;
            const commentsField = jobDetails.querySelector('#friend_comments');

            const resumeField = jobDetails.querySelector('#resumeUpload');
            if (resumeField.files.length > 0) {
                friendResumeFile = resumeField.files[0];
            }
            var recruiterName,recruiterEmailselect,recruiterEmail;
            recruiterEmailselect = jobDetails.querySelector('#recruiterEmail');
            recruiterEmail = recruiterEmailselect?.value || ''
            recruiterName = recruiterEmailselect.getAttribute('data-recruiterName');
            const recruiterMYR = JSON.parse(localStorage.getItem("RECRUITER_DETAILS"));
            if(recruiterMYR && recruiterMYR.recruiterName && recruiterMYR.recruiterEmail){
               recruiterName = recruiterMYR.recruiterName;
               recruiterEmail = recruiterMYR.recruiterEmail;
            }
            const isValidated =
                validateUserFields(myFirstNameField, myLastNameField, myEmailField, myPhoneNumberField, yourPhoneInput) &&
                validateUserFields(firstNameField, lastNameField, emailField, phoneNumberField, friendPhoneInput) &&
                validateResume(resumeField,resumePreview);
            if(isValidated){
              if(myEmailField.value.trim() === emailField.value.trim()) {
                    displayValidationMessage(emailField, __t['referAFriend.emailRepeatedError']);
                    return;
              } else if(myPhone.trim() === friendPhone.trim()) {
                    displayValidationMessage(phoneNumberField, __t['referAFriend.phoneNumberRepeatedError']);
                    return;
              }
              const jobReferralRequest = {
                sessionToken: "",
                commonUserInfo : {
                "userId": 0,
                "firstName": myFirstNameField.value,
                "lastName": myLastNameField.value,
                "email": myEmailField.value,
                "countryCode": myCountryCode,
                "phoneNumber": myPhone,
                "mobile": myPhoneNational,
                "phoneNumberValid": false,
                "recruiterName":recruiterName || "",
                "recruiterEmail": recruiterEmail || "",
                "resume": {
                  "fileGUID": "",
                  "reference": ""
                },
                "additionalNote": "",
                "wereYouReferred": false
                },
                friendList : [{
                "userId": 0,
                "firstName": firstNameField.value,
                "lastName": lastNameField.value,
                "email": emailField.value,
                "countryCode": frdCountryCode,
                "phoneNumber": friendPhone,
                "mobile": friendPhoneNational,
                "phoneNumberValid": false,
                "recruiterName": "",
                "recruiterEmail": "",
                "resume": {
                  "fileGUID": "",
                  "reference": ""
                },
                "additionalNote": commentsField?.value,
                "wereYouReferred": false,
                "resumeFile": {}
                }],
                companyCode : companyCode,
                jobPostingId : companyData.jobid,
                referralType : "02",
                referralCode : "",
                sourceChannelValue : ""
              };
              const formData = new FormData();
              formData.append('jobReferralRequest',JSON.stringify(jobReferralRequest));
              if (friendResumeFile != null) {
                formData.append('resumeFile', friendResumeFile);
              }
              var response = await anonJobRfr(formData);
              const referralForm = jobDetails.querySelector("#referrl-form");
              if(response.success == true) {
                showToast(response.successMessage || "Referral successfully submitted. Thanks!", "success")
                if(referralForm){
                    referralForm.scrollIntoView({ behavior: "smooth", block: "start" });
                }
                const friendEmail = emailField?.value?.trim();
                resetReferralForm();
                const referralFormClose = jobDetails.querySelector(".job-detail__job-referal-form");
                setTimeout(() => {
                 referralFormClose.classList.remove("expand");
                }, 2000);
                mailClientOpener(response, friendEmail);
              }else if(response.errorCode == "1527"){
                if(response.errorMessage.toLowerCase().includes("phone")) {
                  displayValidationMessage(phoneNumberField, response.errorMessage);
                } else{
                  displayValidationMessage(emailField, response.errorMessage);
                }
              }else {
                 showToast(response.errorMessage || "Something went wrong", "fail")
                 if(referralForm){
                    referralForm.scrollIntoView({ behavior: "smooth", block: "start" });
                 }
              }
            }
          }catch (err) {
              console.log("Referral submit error:", err);
              showToast("Something went wrong ! try again", "fail") 
              const referralForm = jobDetails.querySelector("#referrl-form");
              if(referralForm){
                    referralForm.scrollIntoView({ behavior: "smooth", block: "start" });
              }     
          }
        });
      }
      function resetReferralForm() {
        const referrlInfo = jobDetails.querySelector("#job-referal-data");
        if (!referrlInfo) return;
        referrlInfo.querySelectorAll("input, textarea").forEach(el => {
          if (el.type === "file") {
            el.value = ""; 
          } else if (el.type === "checkbox" || el.type === "radio") {
            el.checked = false;
          } else {
            el.value = "";
          }
        });

        // Hide resume preview if any
        const resumePreview = jobDetails.querySelector("#resumePreview");
        if (resumePreview) resumePreview.classList.add("d-none");
        const resumeError = jobDetails.querySelector("#resumeError");
        if (resumeError) resumeError.classList.add("d-none");
        const resumeUploadArea = jobDetails.querySelector("#uploadArea");
        if (resumeUploadArea) resumeUploadArea.classList.remove("d-none");
      }
      function mailClientOpener(referralResponse, friendEmail) {
          console.log("friendEmail........",friendEmail);
          let messageBody = "";
          const {
            referralDetail : { eventName: subject, referralMessages},
          } = referralResponse;
          let referralMessagesArr = referralMessages.filter(msg => msg.type === "01");
          if(referralMessagesArr && referralMessagesArr.length > 0) {
            let body = referralMessagesArr[0].messageBody.replace(/<br\s*\/?>/g, '\r\n');
            messageBody = encodeURIComponent(body);
          }
          window.location.href = `mailto:${friendEmail}?subject=${encodeURIComponent(subject)}&body=${messageBody}`;
      }

      function showToast(message, type = "success") {
        const container = jobDetails.querySelector("#toast-container");
        const toast = document.createElement("div");

        toast.textContent = message;
        toast.style.minWidth = "250px";
        toast.style.marginBottom = "10px";
        toast.style.padding = "12px 16px";
        toast.style.borderRadius = "6px";
        toast.style.color = "#fff";
        toast.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
        toast.style.opacity = "0.95";
        toast.style.fontSize = "14px";
        toast.style.transition = "opacity 0.5s ease";

        if (type === "success") {
          toast.style.backgroundColor = "#28a745"; // green
        } else {
          toast.style.backgroundColor = "#dc3545"; // red
        }

        container.appendChild(toast);

        // Auto remove after 3 sec
        setTimeout(() => {
          toast.style.opacity = "0";
          setTimeout(() => toast.remove(), 500);
        }, 3000);
      } 
      function validateUserFields(firstName, lastName, emailField, phoneField, phoneInput) {

          firstName.setCustomValidity('');
          lastName.setCustomValidity('');
          emailField.setCustomValidity('');
          phoneField.setCustomValidity('');

          if (!(firstName.value.length > 0)) {
            displayValidationMessage(firstName,"Please enter first name.");
            return false;
          }

          if (lastName.value.length < 3) {
            const message = lastName.value.length === 0
              ? 'Please enter last name'
              : 'Last Name should contain more than 2 characters.';

            displayValidationMessage(lastName, message);
            return false;
          }

          if (emailField.value.length == 0 || !validateEmail(emailField.value)) {
            displayValidationMessage(emailField, emailField.value.length ? "Please enter a valid email." : 'Please fill out email.');
            return false;
          }

          if (!(phoneField.value.length > 0 && phoneInput.isValidNumber())) {
            displayValidationMessage(phoneField, phoneField.value.length ? 'Please enter a valid phone number.' : "Please fill out phone number.");
            return false;
          }
          return true;
      };
      function validateResume(resumeField,resumeWrapper) {
          const MAX_SIZE = 2097152;
          resumeField.setCustomValidity('');

          var allowedTypes = companyData['resumetypesallowed'].split(",");

          if (resumeField.files.length > 0) {
            const file = resumeField.files[0];
            if (!allowedTypes.includes(file.type)) {
              displayResumeValidationMessage(resumeField,resumeWrapper, __t['quickApply.resumeErrorInvalid']);
              return false;
            } else if (file.size > MAX_SIZE) {
              displayResumeValidationMessage(resumeField,resumeWrapper, __t['referAFriend.fileSizeError']);
              return false;
            }
          }

          return true;
      };
      function addDropDown(parent, input, arr, filterSlugAlias, filterName, fieldType, displayType, selectField) {

          var dropDown = parent.querySelector(`#${input.id}-dropdown-list`);
          if(dropDown) dropDown.remove();

          dropDown = document.createElement('DIV');
          dropDown.setAttribute('id', `${input.id}-dropdown-list`);
          dropDown.setAttribute('class', 'dropdown-fields');
          input.parentNode.appendChild(dropDown);

          const value = input.value;
         

          for (let i = 0; i < arr.length; i++) {
            const option = document.createElement('option');
            option.setAttribute('value', arr[i].value);
            option.setAttribute('text', arr[i].display);
            selectField.appendChild(option);
            if (value) {
              if (arr[i].display.toUpperCase().includes(value.toUpperCase())) {
                const dropDownField = addDropDownField(arr[i].display, arr[i].value, filterSlugAlias, filterName, fieldType, displayType, selectField, arr[i].extraValue);
                dropDown.appendChild(dropDownField);
              }
            } else {
              const dropDownField = addDropDownField(arr[i].display, arr[i].value, filterSlugAlias, filterName, fieldType, displayType, selectField, arr[i].extraValue);
              dropDown.appendChild(dropDownField);
            }
          }

          input.addEventListener('focusout', () => {
            setTimeout(() => {closeDropDown(dropDown); }, 500);
          });
          input.addEventListener('focus', () => {
            addActive(dropDown);
          });

          addActive(dropDown);

          function addDropDownField(display, value, filterSlugAlias, filterName, fieldType, displayType, selectField, extraValue) {
            const field = document.createElement('DIV');
            field.innerHTML = display;
            field.innerHTML += `<input type="hidden" value="${display}">`;
            field.innerHTML += `<input type="hidden" value="${value}">`;
            if(extraValue)field.innerHTML += `<input type="hidden" value="${extraValue}">`;
            field.addEventListener('click', function (e) {
                const display = this.getElementsByTagName('input')[0].value; 
                const value = this.getElementsByTagName('input')[1].value;   
                const extraValue = this.getElementsByTagName('input')[2]?.value;

                input.value = display;
                selectField.value = value;
                selectField.setAttribute('data-extraValue', extraValue);
                selectField.setAttribute('data-recruiterName',display);
                const recruiterNameSelect = jobDetails.querySelector('#recruiterName');
                if (recruiterNameSelect) {
                  recruiterNameSelect.value = display;
                }

                var dropDown = parent.querySelector(`#${input.id}-dropdown-list`);
                const type = (displayType == 'multi-select') ? 'checkbox' : 'radio';
                var selectedFields = null;

                closeDropDown(dropDown);
                selectedFields = parent.querySelector('.filters__advanced__list__filter__applied');
                if (selectedFields) {
                  if (type == 'radio') selectedFields.innerHTML = display;
                  selectedFields.innerHTML +=
                    `<div class="filters__advanced__list__filter__applied__value multi-select__${filterName}__${value}" data-filterdata="${filterName}__${value}">
                      <input type="${type}" class="btn-check" id="${filterName}__${value}" name="${filterSlugAlias}" value="${display}" data-filtername="${filterName}" data-fieldtype="${fieldType}" data-displaytype="${displayType}" checked>
                      <label class="btn btn-outline-primary custom" for="${filterName}__${value}">${display}</label>
                    </div>`;
                } else {
                  selectedFields = document.getElementById(`${filterName}__${value}`);
                  if (selectedFields) selectedFields.checked = true;
                }
              });

            return field;
          }
          function addActive(dropDown) {
            if (!dropDown) return false;
            dropDown.classList.add('dropdown-active');
          }
          function closeDropDown(dropDown) {
            if (!dropDown) return false;
            dropDown.classList.remove('dropdown-active');
          }
      };
      function formatPhoneNumber(phoneNumber) {
          phoneNumber = phoneNumber.replace(/\D/g, "");

          if (phoneNumber.length <= 3) {
            return phoneNumber;
          } else if(phoneNumber.length <= 6 && companyData.phonedefaultcountry !== 'GB') {
            return ` (${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
          }
          else if (companyData.phonedefaultcountry === 'GB'){
            if (phoneNumber.length <= 7)
            {
              return ` ${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3)}`
            }else
          {
            return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(
              3,
              7
            )} ${phoneNumber.slice(7,11)}`
          }}
          else {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
              3,
              6
            )} ${phoneNumber.slice(6,10)}`;
          } 
      }
      function displayResumeValidationMessage(inputField, wrapper, message) {
        try {
          // inputField.setCustomValidity(message || __t['global.requiredField']);
          // inputField.reportValidity();
          wrapper.classList.add("border-danger");
          wrapper.classList.remove("border-2", "border-dashed");
          const errorElement = jobDetails.querySelector("#resumeError");
          errorElement.textContent = message;
          errorElement.classList.remove("d-none");

          console.log("Validation message:", message);
        } catch (err) {
          console.error("Validation error:", err);
        }
      }
      function clearValidationMessage(inputField, wrapper) {
        wrapper.classList.remove("border-danger");
        wrapper.classList.add("border-2", "border-dashed");
        const errorElement = jobDetails.querySelector("#resumeError");
        errorElement.textContent = "";
        errorElement.classList.add("d-none");
        inputField.setCustomValidity(""); 
      }
      // job referral loginc ends here
  

      let externalJobUrl = '';
      const modal = document.getElementById('externalApplyModal');
      const cancelBtn = document.getElementById('close-external-modal');
      const okBtn = document.getElementById('confirm-external-apply');
      const applyButtons = jobDetails.querySelectorAll('.btn-external-apply');
      applyButtons.forEach((btn) => {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            externalJobUrl = btn.getAttribute('data-url');
            modal.style.display = 'block';
          });
      });
      if (cancelBtn) {
          cancelBtn.addEventListener('click', function () {
             const job = document.getElementById("job-data").dataset;
             const id = job["jobid"];
             logWLAnalyticsEvent("Clicked on External Job Apply", {
              buttonClicked: 'CANCEL',
              jobPostingId: id
            });
            modal.style.display = 'none';
            externalJobUrl = '';
          });
      }
      if (okBtn) {
          okBtn.addEventListener('click', function () {
            const job = document.getElementById("job-data").dataset;
            const id = job["jobid"];
            logWLAnalyticsEvent("Clicked on External Job Apply", {
              buttonClicked: 'OK',
              jobPostingId: id,
            });
          
            if (externalJobUrl) {
              window.open(externalJobUrl, '_blank');
              modal.style.display = 'none';
              externalJobUrl = '';
            }
        });
      }


      function displayValidationMessage(field, message) {
          try {
            field.focus();
            setTimeout(() => {
              field.setCustomValidity(message || __t['global.requiredField']);
              field.reportValidity();
             }, 700);
          } catch (err) {
            console.log(err);
          }
      };
const quickJobApplicationPage = jobDetails.querySelector("#quickResumeApply")
      if (quickJobApplicationPage) {
        const companyData = jobDetails.querySelector("#quickResumeApplyDetails").dataset;
        const quickApplyOriginChannel = companyData['quickapplyoriginchannel'];
        console.log("Quick Apply originChannel from CMS config:", quickApplyOriginChannel);
        nonBranchedQuestionTemplateId = companyData['questiontemplateid']
        console.log(nonBranchedQuestionTemplateId,"check heree...???")

        const apiData = jobDetails.querySelectorAll(".apiData");
        const apiResponse = Array.from(apiData).map((apis) =>
          apis.getAttribute("id")
        );

        const account = jobDetails.querySelector("#account");
        const submitForm = jobDetails.querySelector("#quickapply-submit");
        const emailInput = jobDetails.querySelector("#emailInput");
        const phoneField = jobDetails.querySelector("#phone");
        const captchaErrorMessage = jobDetails.querySelector(
          "#captchaErrorMessage"
        );
        emailInput.addEventListener("keydown", () => {
          emailInput.setCustomValidity("");
        });
        phoneField.addEventListener("keydown", () => {
          phoneField.setCustomValidity("");
        });

        function formatPhoneNumber(value, country) {
          let digits = value.replace(/\D/g, "");
          const maxLength = getMaxLength(country);
          digits = digits.slice(0, maxLength);
          const formatter = new libphonenumber.AsYouType(country);
          return formatter.input(digits);
        }
        function getMaxLength(country) {
          const metadata = new libphonenumber.Metadata();
          metadata.selectNumberingPlan(country);
          const possibleLengths = metadata.numberingPlan.possibleLengths();
          return Math.max(...possibleLengths);
        }
        
        
        function reformatPhone() {
          const selected = phoneInputQuickApply.getSelectedCountry()?.iso2?.toUpperCase();
          const fallback = companyData.phonedefaultcountry?.toUpperCase();
          const country = selected || fallback;
          let digits = phoneField.value.replace(/\D/g, "");    
          digits = digits.substring(0, getMaxLength(country));
          const formatter = new libphonenumber.AsYouType(country);
          phoneField.value = formatter.input(digits);
        }

        phoneField.addEventListener("input", reformatPhone);
        phoneField.addEventListener("countrychange", reformatPhone);
       
        var multiselect = jobDetails.querySelectorAll(".multiselect");
        var options = document.querySelectorAll(
          '.dropdown input[type="checkbox"]'
        );
        var answerTexts = document.querySelectorAll(".dropdown li");
        var selectedDiv = jobDetails.querySelector("#selected");
        var dropdownDiv = jobDetails.querySelector(".dropdown");
        var ratingArea = jobDetails.querySelector(".ratingArea");
        var ratingButtons = document.getElementsByName("rating");
        const MinTextCount = jobDetails.querySelectorAll('.setMinCount')
        var singleselect = jobDetails.querySelectorAll(".singleselect");
        var datePicker = jobDetails.querySelectorAll(".datePicker");
        const selectElement = jobDetails.querySelectorAll(".radio");
        const textareaField = jobDetails.querySelectorAll(".textareaField");
        var textInput = jobDetails.querySelectorAll(".textInputArea");
        var isAtBranchEnd = false;
        var answerChangedBranchedQuestionnaire = false;
        let selectedAnswerIDs = [];
        let answerName = [];
        let selectedOption = [];
        let ratingValue = [];
        let TextValue=[];
        let DateTime =[];
        let jobPostingId=0
        const multiError = jobDetails.querySelector("#multiError");
        const singleError = jobDetails.querySelector("#singleError");
        const ratingError = jobDetails.querySelector("#ratingError");
        const shortTextError = jobDetails.querySelector("#shortTextError");

        document.addEventListener('click', (event) => {
          // deselectText()
          multiselect.forEach((select) => {

            const dropdownDiv = select.querySelector('.dropdown');
            if (dropdownDiv.style.display === 'block' && !select.contains(event.target)) {
              dropdownDiv.style.display = 'none';
            }
          });

          singleselect.forEach((select) => {
            const dropdownDiv = select.querySelector('.dropdown');
            var isDropDwon =event.currentTarget.querySelector(".dropdown");

            if (dropdownDiv.style.display === 'block' && !select.contains(event.target)) {
              dropdownDiv.style.display = 'none';
            }
          });
        });
        const data = document.getElementById("api-data").dataset;
        const companyCode = data["companycode"];
        const baseUrl = data["baseurl"];
        const questionnaireHeading = jobDetails.querySelector(
          "#questionnaireHeading"
        );
        const questionnaireSection = jobDetails.querySelector(
          "#questionnaireSection"
        );

        let questionRequired = jobDetails.querySelectorAll(".questionRequired");
        let requiredQuestions=[]
       for(var i=0;i< MinTextCount.length;i++){
        MinTextCount[i].innerHTML = 0;

       }
        const requiredArray = Array.from(questionRequired).map((req) =>{
          let obj={}
          obj['id']=req.getAttribute('id')
          obj['type']=req.getAttribute('type')
          if(req.getAttribute('minLength')&& req.getAttribute('minLength').length>0){
            obj['minlength']=parseInt(req.getAttribute('minLength'))
          }
            requiredQuestions.push(obj)

        }
        );

        var questionElements = jobDetails.querySelectorAll(".question");
        var questionData = Array.from(questionElements).map(
          (questionElement) => {
            const [questionID, questionType] = questionElement
              .getAttribute("id")
              .split("_");
            return [questionID, questionType];
          }
        );


        if (apiResponse.length > 0) {
          const questions = jobDetails.querySelectorAll('.ql-editor');
          if (questions.length > 0) {
            questionnaireHeading.innerHTML = jobDetails.dataset.questionnaireHeadingText || __t['quickApply.questionnaireDefaultTitle'];
            questionnaireSection?.classList.add("block");
          } else {
            questionnaireSection?.classList.remove("block");
            questionnaireHeading.innerHTML = "";
          }
        }

        if (true ) {

multiselect.forEach(function (select) {
  select?.addEventListener("click",event=> {
    multiSelectDropDown(select,event);
    dropDownDisplayStyle(event)


  })
});

// multiselect.forEach(function (select) {
//   select?.addEventListener("input",event=> {


//   })
// });



          ratingButtons.forEach(function (ratingButton) {
            ratingButton?.addEventListener("click", function () {
              if (this.checked) {
                radioButtonSelect(this.checked,ratingArea,ratingButton)
              }
            });
          });
          singleselect.forEach(function (selectElem) {
          selectElem?.addEventListener("click", event=> {
            singleSelectDropDown(selectElem,event)
            dropDownDisplayStyle(event)

          });
        });

        datePicker.forEach(function (selectElem) {
          selectElem?.addEventListener("click", event=> {

            datePickerEvent(selectElem,event)

          });
        });
          if (textareaField) {
            textInput.forEach(function (textinp) {
              textinp?.addEventListener("input", function () {
                textApplyButton(textinp)
            }
           );
          });

          }
        }




var multiSelectInputs = jobDetails.querySelectorAll('.inputBoxMultiSelect');

multiSelectInputs.forEach(function(multiSelectInput) {
    if(multiSelectInput){
    multiSelectInput.addEventListener('input', function(event) {
      var  userInput= event.target.value;
      var questionnaireId= event.target.dataset
      var answerList = JSON.parse(questionnaireId['multiselectquestions']);
      var questionId = questionnaireId['questionid']
      var filteredAnswers=[]
     var filteredAnswers= answerList.filter(answer =>{return answer.answerValue.toLowerCase().includes(userInput.toLowerCase())});
      var allDiv = Array.from(document.getElementsByClassName('multiselectdiv'+questionId));



      for(var i=0;i<filteredAnswers.length;i++){
        for(var j=0;j<allDiv.length;j++){
          let checkbox1= allDiv[j].querySelector('input[type="checkbox"]')
          if(checkbox1.id === filteredAnswers[i].answerValue){
            allDiv[j].classList.remove('hide')
            allDiv.splice(j, 1);
            j=j-1;
          }
          else {
            allDiv[j].classList.add('hide')
          }
        }
      }
      ;

    });
    multiSelectInput.addEventListener('click',function(event) {
      var  userInput= event.target.value;
      if(userInput.trim().length==0){
        var questionnaireId= event.target.dataset

      var questionId = questionnaireId['questionid']
      var allDiv = Array.from(document.getElementsByClassName('multiselectdiv'+questionId));

      var answerList = JSON.parse(questionnaireId['multiselectquestions']);
      for(var i=0;i<answerList.length;i++){
         allDiv[i].classList.remove('hide')

      }
      }
    })
  }
});

var singleselectInputs =  jobDetails.querySelectorAll('.inputBoxSingleSelect');
singleselectInputs.forEach(function(singleSelectInput) {
  if(singleSelectInput){
    singleSelectInput.addEventListener('input', function(event) {
    var  userInput= event.target.value;
    var questionnaireId= event.target.dataset
    var answerList = JSON.parse(questionnaireId['singleselectquestions']);
    var questionId = questionnaireId['questionid']
   var filteredAnswers= answerList.filter(answer => answer.answerValue.toLowerCase().includes(userInput.toLowerCase()));
    var allDiv = Array.from(document.getElementsByClassName('singleselectdiv'+questionId));

    for(var i=0;i<filteredAnswers.length;i++){
      for(var j=0;j<allDiv.length;j++){
        let checkbox1= allDiv[j].querySelector('input')
        if(checkbox1.id === filteredAnswers[i].answerValue){
          allDiv[j].classList.remove('hide')
          allDiv.splice(j, 1);
          j=j-1;

        }
        else {
          allDiv[j].classList.add('hide')

        }
      }
    }


  });
  singleSelectInput.addEventListener('click',function(event) {
    var  userInput= event.target.value;
    if(userInput.trim().length==0){
      var questionnaireId= event.target.dataset

    var questionId = questionnaireId['questionid']
    var allDiv = Array.from(document.getElementsByClassName('singleselectdiv'+questionId));

    var answerList = JSON.parse(questionnaireId['singleselectquestions']);
    for(var i=0;i<answerList.length;i++){
       allDiv[i].classList.remove('hide')

    }
    }
  })
}
});



        if (submitForm) {

          submitForm?.addEventListener("click", async () => {
            QuestionnaireValidated =true
            if (captchaErrorMessage) {
              captchaErrorMessage.style.display = "none";
            }
            let isBranched = false
            if(isBranchedQuestionnaire){
              isBranched = true
              var resp =null
              if(questionData.length>0){
                var resp= getAnswerList()
                ValidateQuestionnaire(questionRequired,resp.userAnswerResponse)

               }
            let  req=createRequestPayload("next",resp.lastQuestionId,templateId,jobPostingId,resp.userAnswerResponse,userId,true)

            var response2 =  await branchedQuestionsFetch(req, recommendedJobsOptions.enabled)
            }

            var phone = "";
            var file = null;
            var terms = false;
            var notifications ={ "WHATSAPP": false }
            const firstName = jobDetails.querySelector("#firstName");
            const lastName = jobDetails.querySelector("#lastName");
            const emailInput = jobDetails.querySelector("#emailInput");
            const termsField = jobDetails.querySelector("#QuickApplyterms");
            const termsField2 = jobDetails.querySelector("#QuickApplyterms2");
            const termsField3 = jobDetails.querySelector("#QuickApplyterms3");
            const quickApplySmOptIn = jobDetails.querySelector("#quickApplySmOptIn")
            const phoneField = jobDetails.querySelector("#phone");
            const resumeField = jobDetails.querySelector("#quickapply-resume");
            const userSourceType = companyData['usersourcetype']
            const data = document.getElementById("job-data").dataset;
            const jobId = data["jobid"];

            if (
              companyData["resumeuploadrequired"] == "01" ||
              (companyData["resumeuploadrequired"] == "02" &&
                resumeField.files.length > 0)
            ) {
              file = resumeField.files[0];
            }

            const MAX_SIZE = 5242880;
            if (file) {
              resumeField.setCustomValidity("");
            }
            if (file && file.size > MAX_SIZE) {
              displayValidationMessage(
                resumeField,
                __t['quickApply.resumeErrorFileSize']
              );
              return;
            }
            if (companyData["termsandservices"] == "true") {
              terms = termsField.checked;
            }

             var questionResponseDataArray = [];
             if(!isBranchedQuestionnaire){
            questionData.forEach((data) => {
              const questionID = data[0];
              const questionType = data[1];

              if (
                questionType === "06") {
                var answerList= fetchAnswer(ratingValue,questionID,questionType)
                const questionObject1 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: answerList,
                    questionTextResponse: "",
                  },
                };
                questionResponseDataArray.push(questionObject1);
              } else if (
                questionType === "01"
              ) {
               var answerList= fetchAnswer(selectedAnswerIDs,questionID,questionType)
                const questionObject2 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: answerList,
                    questionTextResponse: "",
                  },
                };
                questionResponseDataArray.push(questionObject2);
              } else if (
                questionType === "03"
              ) {
                var answerList= fetchAnswer(selectedOption,questionID,questionType)
                const questionObject3 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: answerList,
                    questionTextResponse: "",
                  },
                };
                questionResponseDataArray.push(questionObject3);
              } else if (
                questionType === "04" ||
                questionType === "02" ||
                (questionType === "11")
              ) {
                var answerList= fetchAnswer(TextValue,questionID, questionType)
                const questionObject4 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: [],
                    questionTextResponse: answerList,
                  },
                };
                questionResponseDataArray.push(questionObject4);
              }
            });


            if(questionData.length>0){

             ValidateQuestionnaire(questionRequired,questionResponseDataArray)

            }
             }
             let isValidated = true;
             isValidated = validateFields(firstName,lastName,emailInput,termsField,termsField2,termsField3,phoneField,resumeField,file);
             if(quickApplySmOptIn){
                notifications.SMS = quickApplySmOptIn.checked
             }
             phone = phoneInputQuickApply.getNumber();
             if (isValidated && QuestionnaireValidated) {
              const userData = {
                userName: emailInput?.value,
                firstName: firstName?.value,
                lastName: lastName?.value,
                email: emailInput?.value,
                password: "",
                phone: phone,
                phoneNumberValid: true,
                companyCode: companyCode,
                sourceType: "",
                referralUrl: "",
                referralCode: "",
                userDeviceAppTkn: "",
                duplicateCheckRequired: true,
                isEmailSystemGenerated: true,
                completeRegistration: false,
                userAgreement: terms,
                marketingEmailFlag: false,
                enabled: true,
                userId:userId,
                notificationTypeMap: notifications,
                userSourceType: userSourceType
              };
              var questionnaireData={}
              if(!branchedQuestionnaire){
              questionnaireData = {
                userId: 0,
                jobPostingId: jobId,
                questionResponseData: questionResponseDataArray,
                referralCode: "",
                questionTemplateId:parseInt(nonBranchedQuestionTemplateId)
              };
            }
            else if(isBranched ){
              questionnaireData = {
                userId: userId,
                jobPostingId: jobId,
                questionTemplateId:parseInt(templateId)
              };
            }

              const formData = new FormData();
              formData.append("user", JSON.stringify(userData));


              if((questionnaireData.questionResponseData!=null && questionnaireData.questionResponseData.length>0)|| isBranched){
              formData.append(
                "questionnaireInfo",
                JSON.stringify(questionnaireData)
              );
              }

              formData.append("jobPostingId", jobId);

              formData.append("companyCode", companyCode);

              formData.append("userAgreement", true);
              formData.append("isBranched",isBranched)
              if (quickApplyOriginChannel) {
                console.log("Appending originChannel to quick apply submit:", quickApplyOriginChannel);
                formData.append("originChannel", quickApplyOriginChannel);
              }

              if (utmTrackerId) {
                formData.append('utmTrackerId', utmTrackerId);
              }

              if (file != null) {
                formData.append("resumefile", file);
              }
              formData.append(
                "resume",
                `{"resumename":"","resumeLink":"","jobpostingid": ${jobId}}`
              );
              formData.append("resumeUploadRequired", companyData['resumeuploadrequired'])
              formData.append('userAgent',"WL-CMS")
              // formData.append("context", "QUICK_APPLY");
              var spinner = jobDetails.querySelector("#quick-apply-spinner");
              var overlay = jobDetails.querySelector("#quick-apply-overlay");

              overlay.style.display = "block";
              spinner.style.display = "block";

              var response = await quickJobApplyJobDetails(formData,companyData['resumeuploadrequired'], recommendedJobsOptions);
              if (response.success == true) {
                jobDetails.querySelector("#firstName").value = "";
                jobDetails.querySelector("#lastName").value = "";
                jobDetails.querySelector("#phone").value = "";
                if (apiResponse.length > 0) {
                  // jobDetails.querySelector(".textInputArea").value = "";
                  selectedAnswerIDs = [];
                  selectedOption = [];
                  ratingValue = [];
                }

                overlay.style.display = "none";
                spinner.style.display = "none";
                if (
                  companyData["resumeuploadrequired"] == "01" ||
                  (companyData["resumeuploadrequired"] == "02" &&
                    jobDetails.querySelector("#quickapply-resume").files
                      .length > 0)
                ) {
                  jobDetails.querySelector("#quickapply-resume").value = null;
                }
                if (companyData["termsandservices"] == "true") {
                  termsField.checked = false;
                }
                jobDetails.querySelector("#quickResumeApply").remove();
                jobDetails.querySelector("#post-data").style.display = "block";

                const currentURL = window.location.href;
                const newURL = new URL(currentURL);
                // if(!externalUrl){
                  newURL.searchParams.set('successfullyApplied', 'true');
                //}
                window.history.replaceState(null, '', newURL.toString());

                if (recommendedJobsContainer) {
                  // TODO check when error response
                  recommendedJobsContainer.style.display = null;
                  recommendedJobsContainer
                    .querySelector('.recommended-jobs-widget')
                    .dispatchEvent(new Event(LOAD_RECOMMENDED_JOBS_EVENT));
                }

                showSuccessMessage(
                  "Submit your Resume",
                  "Resume submitted successfully!"
                );

                // Track Click on Submit Quick Apply Button
                var jobData = document.querySelector("#job-data");
                logWLAnalyticsEvent(`Job Apply Submitted`, {
                  userId: response.userId,
                  jobPostingId: jobData?.dataset?.jobid,
                  jobTitle: jobData?.dataset?.jobtitle,
                  quickApply: true,
                  resumeAttached: file != null,
                  questionnaireId: questionnaireData?.questionTemplateId,
                  loggedIn: false,
                });
                if(jobData?.dataset && response.userId)
                  jobData.dataset.userId = response.userId;

              } else {
                const errorMessage = response.split(".")[0];

                spinner.style.display = "none";
                overlay.style.display = "none";

                if (!errorMessage) return false;
                showErrorMessage("Submit your Resume", errorMessage);
                const lowerErrorMessage = errorMessage.toLowerCase();
                if (
                  lowerErrorMessage.indexOf(
                    "this email address is already in use"
                  ) >= 0
                ) {
                  jobDetails.querySelector(
                    "#quick-apply-existing-user"
                  ).style.display = "block";
                  window.scrollTo({ top: 0, behavior: 'smooth' });

                  appendLoginUrl()
                  oldEmail=emailInput.value
                } else if (
                  lowerErrorMessage.indexOf(
                    "you have already applied for this job"
                  ) >= 0
                ) {
                  jobDetails.querySelector("#alreadyApplied").style.display =
                    "block";
                } else if (lowerErrorMessage.indexOf("email") >= 0) {
                  displayValidationMessage(
                    jobDetails.querySelector("#emailInput"),
                    errorMessage
                  );
                } else if (lowerErrorMessage.indexOf("phone") >= 0) {
                  displayValidationMessage(
                    jobDetails.querySelector("#phone"),
                    errorMessage
                  );
                } else if (lowerErrorMessage.indexOf("first name") >= 0) {
                  displayValidationMessage(
                    jobDetails.querySelector("#firstName"),
                    errorMessage
                  );
                } else if (lowerErrorMessage.indexOf("last name") >= 0) {
                  displayValidationMessage(
                    jobDetails.querySelector("#lastName"),
                    errorMessage
                  );
                } else if (lowerErrorMessage.indexOf("resume") >= 0) {
                  displayValidationMessage(resumeField, response);
                }
              }
            }
            return false;
          });
        }


        if (account) {
          account.addEventListener("click", async () => {
            console.log("locale check")
            let locale = window.apos?.locale;
            let urlToOpen = `${baseUrl}/atsuser/v2/login?userName=${emailInput?.value}&postQuickApplySignupAction=true&locale=${locale}`;
            let currentQueryParams = window.location.search;
            if(externalUrl){
              urlToOpen = externalUrl;
            }else{
              if (currentQueryParams) {
              currentQueryParams = currentQueryParams.substring(1);
              urlToOpen += `&${currentQueryParams}`;
              }if (window.sessionStorage.utm_source) {
              urlToOpen += `&utm_source=${window.sessionStorage.utm_source}`;
              }if (window.sessionStorage.utm_medium) {
              urlToOpen += `&utm_medium=${window.sessionStorage.utm_medium}`;
              }if (window.sessionStorage.utm_campaign) {
              urlToOpen += `&utm_campaign=${window.sessionStorage.utm_campaign}`;
              }
            }
            window.open(urlToOpen);
            
            // Track Click on Complete Account Now Button
            var jobData = document.querySelector("#job-data");
            logWLAnalyticsEvent("Complete Account Selected", {
              userId: jobData?.dataset?.userId,
            });
          });
          jobDetails.querySelector("#emailInput").value = "";
        }
        function displayErrorMessage(errorContainer, message) {
          let errordiv = document.getElementById(errorContainer);
          let test = jobDetails.querySelectorAll('.singleselectErr')
          let errorMessage = errordiv.querySelector('.error-message');
          if (!errorMessage) {
            errorMessage = document.createElement('p');
            errorMessage.className = 'error-message';
            errorMessage.style.color = 'red';
            errorMessage.style.fontSize = '12px';
            errorMessage.style.marginTop = '6px';
            errordiv.appendChild(errorMessage);
          }
          QuestionnaireValidated = false
          errorMessage.innerHTML = message;
          errorMessage.style.display='block'
          setTimeout(() => {
           errorMessage.style.display = 'none';
        }, 6000);

        }
        function multiSelectDropDown(select,event){
          if(isAtBranchEnd){
            nextButton.classList.remove('disable')

            submitForm.classList.add('disable')
            isAtBranchEnd = false
          }
          var checkbox=[]
          var questionId= select.getAttribute('question')
          var selectedDiv = event.currentTarget.querySelector("#selected");
          var selectedInput = event.currentTarget.querySelector("#selected input[type='text']")
          var dropdownDiv =event.currentTarget.querySelector(".dropdown");
          var options =  event.currentTarget.querySelectorAll('.dropdown input[type="checkbox"]');
          var Values= event.currentTarget.querySelectorAll('.dropdown input[type="checkbox"]');
          var options1 =  event.currentTarget.querySelectorAll('.dropdown li');
          var multiSelectInput = document.getElementsByClassName('inputBoxMultiSelect');
          options1.forEach((item) => {
              // Get the input element within the clicked list item
              checkbox.push(item.querySelector('input[type="checkbox"]'));
          });





              // dropdownDiv.style.display =  "block";

              let checkedValues=[]

              let multiselectOptions={}

              options1.forEach(option => {
                option.addEventListener('click', event1 => {
            var checkboxSelect= option.querySelector('input[type="checkbox"]')

            if (checkboxSelect && (event1.target.id=='wholediv' || event1.target.id=='labelName')) {
              // Toggle the checkbox state

              checkboxSelect.checked = !checkboxSelect.checked;
            }

        const checkedOptions = Array.from(checkbox)
                    .filter(option => option.checked)
                    .map(option => option.id);
                    if(checkedOptions.length==0){
                      selectedInput.value = ''
                      selectedInput.placeholder=__t['quickApply.multiSelectPlaceholder']
                    }
                    else{
                      selectedInput.value = ''
                      selectedInput.placeholder = checkedOptions.join(', ');
                    }


                  checkedValues = Array.from(checkbox).filter(option => option.checked).map(option => option.value);
                  let test= checkedValues

                  let exists=false;
                  for(i=0;i<selectedAnswerIDs.length;i++){
                    if (selectedAnswerIDs[i]['questionId']== questionId){
                      exists=true
                      selectedAnswerIDs[i]['value']=checkedValues.map(str => parseInt(str))
                    }
                  }
                  if(selectedAnswerIDs.length==0 || !exists){
                    multiselectOptions['questionId']=questionId
                      multiselectOptions['value']=checkedValues.map(str => parseInt(str))
                      multiselectOptions['type']='multiselect'

                      selectedAnswerIDs.push(multiselectOptions);
                  }
                });

                });
        }
        function dropDownDisplayStyle(event)
        {
          var dropdownDiv =event.currentTarget.querySelector(".dropdown");
          dropdownDiv.style.display = dropdownDiv.style.display === 'block' ? 'none' : 'block';

        }
        function datePickerEvent(selectElem,event){
          if(isAtBranchEnd){
            nextButton.classList.remove('disable')

            submitForm.classList.add('disable')
            isAtBranchEnd =false
          }
          var dateObject={}
          var questionId = selectElem.getAttribute('question');
           var date = jobDetails.querySelector("#datePicker_"+questionId)
          if(date){
            var value = date.value
            var isExists=false
            if(DateTime.length>0){
              for(var i=0;i<DateTime.length;i++){
                if(DateTime[i].questionId==questionId){
                  DateTime[i].questionTextResponse=value
                  isExists= true
                }
              }
            }
            if(isExists==false){
              dateObject['questionId']=questionId
              dateObject['value']=value

              dateObject['type']='date'
              DateTime.push(dateObject)

            }

          }

        }
        function singleSelectDropDown(selectElem,event){
          if(isAtBranchEnd){
            nextButton.classList.remove('disable')

            submitForm.classList.add('disable')
            isAtBranchEnd =false
          }
          var checkbox=[]
          var question= selectElem.getAttribute('question')
          var dropdownDiv =event.currentTarget.querySelector(".dropdown");
          var selectedDiv = event.currentTarget.querySelector("#selected input[type='text']");
          // dropdownDiv.style.display =  'block';

          var options= event.currentTarget.querySelectorAll('.dropdown li')
        var value=''
          options.forEach(option => {
            option.addEventListener('click', event1 => {
              var input =option.querySelector('input[type="hidden"]')
              option.style.backgroundColor = 'lightgrey';
              var name= input.getAttribute('id');
              value = input.getAttribute('value').trim();
              if(name!=null){
                selectedDiv.value = "";
                selectedDiv.placeholder=name
              }
              else{
                selectedDiv.placeholder=__t['quickApply.multiSelectPlaceholder']
              }
              if (value.length>0) {

                let selectedOptionObject={}

                let updated=false;
                let exists =false;
                for(i=0;i<selectedOption.length;i++){
                 if (selectedOption[i]['questionId']== question){
                   exists=true
                   selectedOption[i]['value']=[parseInt(value)]
                 }
               }
               if(!exists){

                selectedOptionObject['questionId']=question
                selectedOptionObject['value']= [parseInt(value)]
                selectedOptionObject['type']='rating'
                 selectedOption.push(selectedOptionObject)
               }

               } else {
                 selectedOption = [];
               }

               for(var i=0; i<options.length; i++){
                var input =options[i].querySelector('input[type="hidden"]')
                if(input.getAttribute('value').trim() !=value){
                 options[i].style.backgroundColor = 'white';
                }
               }
            })
          })
        }
        function textApplyButton(textinp){
          if(isAtBranchEnd){
            nextButton.classList.remove('disable')

            submitForm.classList.add('disable')
            isAtBranchEnd =false;
          }
          let id=textinp.getAttribute("question")+"count"
          const count = document.getElementById(id);
        let text={}

       let updated=false;
       for(var i=0; i<TextValue.length;i++){
        if(TextValue[i]['questionId']==textinp.getAttribute("question")){
          if(textinp.getAttribute("type")=='number'){
            if (typeof (textinp.value)== "string"){
            textinp.value = ''
            return false;
            }
          }
          TextValue[i]['value']=textinp.value
          updated=true
        }
       }
       if(!updated){
        text['questionId']=textinp.getAttribute("question")
       text['value']= textinp.value
       text['type']='text'
      text['minlength']=textinp.getAttribute('minlength')
      text['maxlength']=textinp.getAttribute('maxlength')

       TextValue.push(text)
      }

      if(count){
        count.innerHTML = textinp?.value?.length;
      }
        }
        function radioButtonSelect(checked,ratingArea,ratingButton){
          if(isAtBranchEnd){
            nextButton.classList.remove('disable')

            submitForm.classList.add('disable')
            isAtBranchEnd=false
          }
          let ratingArray={}
          let question = ratingArea.getAttribute('question')
          let answer = ratingButton.getAttribute('value')
          let exists=false;
          for(i=0;i<ratingValue.length;i++){

            if (ratingValue[i]['questionId']=== parseInt(question,10)){
              exists=true
              ratingValue[i]['value']=[answer]
            }
          }
          if(ratingValue.length==0 || !exists){

            ratingArray['questionId']=parseInt(question)
            ratingArray['value']=[]
            ratingArray['value'].push(parseInt(answer))
            ratingArray['type']='rating'
            ratingValue.push(ratingArray)
          }
        }

function createQuestionnaires(questions){
  var container = document.getElementById('branchedQuestionnaire');
  container.innerHTML = '';
  selectedOption=[]
        // Loop through the branchedquestionnaireData
        questions.forEach(function(question,index) {
          if (question.questionRequired) {
              var div = document.createElement('div');
              div.id = question.questionID;
              div.setAttribute('type', question.questionType);
              div.className = 'questionRequired';
              container.appendChild(div);
          }

          var questionDiv = document.createElement('div');
          questionDiv.id = question.questionID + '_' + question.questionType;
          questionDiv.className = 'question text-left';
          var spanEle = document.createElement('span')
          spanEle.className= 'ql-editor survey-question-align survey-max-image'
          spanEle.innerHTML = question.questionSequence +'. '+question.questionDesc.replace('<span style="font-size: 14px;">', '').replace('</span>', '');

          questionDiv.appendChild(spanEle)


          if (question.questionRequired) {
              var span = document.createElement('span');
              span.id = question.questionRequired;
              span.className = 'required';
              span.style.color = 'red';
              span.innerHTML = '*';
              questionDiv.appendChild(span);
          }

          container.appendChild(questionDiv);

          var answerListDiv = document.createElement('div');
          answerListDiv.className = 'answerlist';
          if (question.questionType === '01' ) {
            var answerListDiv = document.createElement('div');
            answerListDiv.className = 'answerlist';

            // Create div for multiple choice
            var divMultiSelect = document.createElement('div');
            divMultiSelect.style.display = 'flex';
            divMultiSelect.style.flexDirection = 'column';
            divMultiSelect.className = 'multiselect';
            divMultiSelect.setAttribute('question', question.questionID);

            // Create div for selected options
            var divSelected = document.createElement('div');
            divSelected.id = 'selected';
            var inputMultiSelect = document.createElement('input');
            inputMultiSelect.style.width = '300px';
            inputMultiSelect.style.padding = '6px';
            inputMultiSelect.type = 'text';
            inputMultiSelect.className = 'inputBoxMultiSelect';
            inputMultiSelect.id = 'multiSelect' + question.questionID;
            if(question.questionRequired){
              inputMultiSelect.placeholder = __t['quickApply.multiSelectPlaceholder'] + '*';
            }
            else{
            inputMultiSelect.placeholder = __t['quickApply.multiSelectPlaceholder'];
            }
            inputMultiSelect.dataset.multiselectquestions = JSON.stringify(question.answerList);
            inputMultiSelect.dataset.questionid = question.questionID;
            divSelected.appendChild(inputMultiSelect);
            divMultiSelect.appendChild(divSelected);

            // Create div for dropdown
            var divDropdown = document.createElement('div');
            divDropdown.style.maxHeight = '200px';
            divDropdown.style.overflowY = 'scroll';
            divDropdown.style.display = 'none';
            divDropdown.className = 'dropdown';

            // Create ul for options
            var ul = document.createElement('ul');
            question.answerList.forEach(function(answer) {
                var li = document.createElement('li');
                li.id = 'wholediv';
                li.className = 'multiselectdiv' + question.questionID;
                var inputCheckbox = document.createElement('input');
                inputCheckbox.type = 'checkbox';
                inputCheckbox.value = answer.answerMasterID;
                // if(question.userQuestionResponse==null && question.mappedAttributeValues !=null){
                //   inputCheckbox.value = question.targetFieldValue;
                // }
                // else{
                //   inputCheckbox.value = answer.answerMasterID;

                // }
                inputCheckbox.id = answer.answerValue;
                inputCheckbox.name = 'dropdown';
                inputCheckbox.style.marginTop = '6px';
                var span = document.createElement('span');
                span.id = 'labelName';
                span.style.fontSize = '15px';
                span.style.cursor = 'pointer';
                span.textContent = answer.answerValue;
                li.appendChild(inputCheckbox);
                li.appendChild(span);
                ul.appendChild(li);
            });

            divDropdown.appendChild(ul);
            divMultiSelect.appendChild(divDropdown);

            // Create div for error
            var divError = document.createElement('div');
            divError.id = question.questionID + 'multiError';
            divMultiSelect.appendChild(divError);

            answerListDiv.appendChild(divMultiSelect);
            container.appendChild(answerListDiv);
            var userAnswers=null
            if(question.userQuestionResponse !=null){
             userAnswers= question.userQuestionResponse.userAnswerList
             preMapMultiSelectOption(question.questionID,userAnswers,"multiselect",answerListDiv,question.questionType,false)

            }
            // else if(question.mappedAttributeValues !=null){
            //   userAnswers = question.userQuestionResponse.mappedAttributeValues
            //   preMapMultiSelectOption(question.questionID,userAnswers,"multiselect",answerListDiv,question.questionType,true)

            // }


              // Populate for multiple choice question type
          } else if (question.questionType === '03'  || question.questionType === '12'  ) {
             // Create main div for single select
             var singleSelectDiv = document.createElement('div');
             singleSelectDiv.style.display = 'flex';
             singleSelectDiv.style.flexDirection = 'column';
             singleSelectDiv.className = 'singleselect';
             singleSelectDiv.setAttribute('question', question.questionID);

             // Create div for selected options
             var selectedDiv = document.createElement('div');
             selectedDiv.id = 'selected';
             var inputBox = document.createElement('input');
             inputBox.style.width = '300px';
             inputBox.style.padding = '6px';
             inputBox.type = 'text';
             inputBox.className = 'inputBoxSingleSelect';
             inputBox.id = 'singleSelect' + question.questionID;
             if(question.questionRequired){

             inputBox.placeholder = __t['quickApply.multiSelectPlaceholder']+'*';
             }
             else{
              inputBox.placeholder = __t['quickApply.multiSelectPlaceholder'];

             }
             selectedDiv.appendChild(inputBox);
             singleSelectDiv.appendChild(selectedDiv);

             // Create div for dropdown
             var dropdownDiv = document.createElement('div');
             dropdownDiv.style.maxHeight = '200px';
             dropdownDiv.style.overflowY = 'scroll';
             dropdownDiv.className = 'dropdown';
             var ul = document.createElement('ul');

             // Create list items for options
             question.answerList.forEach(function(answer) {
                 var li = document.createElement('li');
                 li.id = 'wholediv';
                 li.className = 'singleselectdiv' + question.questionID;
                 var inputHidden = document.createElement('input');
                 inputHidden.type = 'hidden';
                 inputHidden.value = answer.answerMasterID;

                //  if(question.userQuestionResponse==null && question.question.mappedAttributeValue !=null){
                //   inputHidden.value = question.targetFieldValue;
                // }
                // else{
                //  inputHidden.value = answer.answerMasterID;
                // }
                 inputHidden.id = answer.answerValue;
                 inputHidden.name = 'dropdown';
                 inputHidden.style.marginTop = '6px';
                 var span = document.createElement('span');
                 span.id = 'labelName';
                 span.style.fontSize = '15px';
                 span.style.cursor = 'pointer';
                 span.textContent = answer.answerValue;
                 li.appendChild(inputHidden);
                 li.appendChild(span);
                 ul.appendChild(li);
             });

             dropdownDiv.appendChild(ul);
             singleSelectDiv.appendChild(dropdownDiv);

             // Create div for error
             var errorDiv = document.createElement('div');
             errorDiv.id = question.questionID + 'singleError';
             errorDiv.className = 'singleselectErr';
             singleSelectDiv.appendChild(errorDiv);

             // Append the single select div to the container
             container.appendChild(singleSelectDiv);
             var userAnswers=null
             if(question.userQuestionResponse !=null){
              userAnswers= question.userQuestionResponse.userAnswerList
              preMapMultiSelectOption(question.questionID,userAnswers,"rating",singleSelectDiv,question.questionType,false)

             }
            //  else if(question.mappedAttributeValue !=null){
            //   userAnswers = question.userQuestionResponse.mappedAttributeValue
            //   preMapMultiSelectOption(question.questionID,userAnswers,"rating",singleSelectDiv,question.questionType,true)

            // }


          } else if (question.questionType === '06') {
              // Populate for rating question type

              var ratingAreaDiv = document.createElement('div');
                ratingAreaDiv.className = 'ratingArea';
                ratingAreaDiv.setAttribute('question', question.questionID);
                var ratingInputReq  = null
               if(question.questionRequired){
                ratingInputReq = document.createElement('div');


                ratingInputReq.innerText = "Required";

                  ratingInputReq.style.color = "red";
                  ratingInputReq.style.fontStyle = "italic";
               }
                // Create rating input divs
                question.answerList.forEach(function(answer) {
                    var ratingInputDiv = document.createElement('div');
                    ratingInputDiv.className = 'ratingInput';
                    ratingInputDiv.setAttribute('question', question.questionID);

                    var inputRadio = document.createElement('input');
                    inputRadio.type = 'radio';
                    inputRadio.name = 'rating';
                    inputRadio.value = answer.answerMasterID;
                    inputRadio.id = 'ratingText_' + answer.answerMasterID;
                    // if(question.userQuestionResponse==null && question.mappedAttributeValue !=null){
                    //   inputRadio.value = question.mappedAttributeValue;
                    //   inputRadio.id = 'ratingText_' + question.mappedAttributeValue;

                    // }
                    // else{
                    //   inputRadio.value = answer.answerMasterID;
                    // inputRadio.id = 'ratingText_' + answer.answerMasterID;
                    // }
                    inputRadio.className = 'rating';

                    var label = document.createElement('label');
                    label.htmlFor = 'ratingText_' + answer.answerMasterID;
                    if(answer.answerValue.length>0){
                    label.textContent = answer.answerValue;
                    }
                    else{
                      label.textContent = answer.answerSequenceNbr
                    }
                    if(ratingInputReq!=null){
                    ratingInputDiv.appendChild(ratingInputReq);
                    }
                    ratingInputDiv.appendChild(inputRadio);
                    ratingInputDiv.appendChild(label);

                    ratingAreaDiv.appendChild(ratingInputDiv);
                });

                // Create rating error div
                var ratingErrorDiv = document.createElement('div');
                ratingErrorDiv.id = question.questionID + 'ratingError';
                ratingErrorDiv.className = 'ratingErr';

                ratingAreaDiv.appendChild(ratingErrorDiv);

                container.appendChild(ratingAreaDiv);
                let userAnswers=null
                if(question.userQuestionResponse !=null){
                  userAnswers= question.userQuestionResponse.userAnswerList
                preMapMultiSelectOption(question.questionID,userAnswers,"rating",ratingAreaDiv,question.questionType,false)
                }
                // else if(question.mappedAttributeValue !=null){
                //   userAnswers = question.userQuestionResponse.mappedAttributeValue
                //   preMapMultiSelectOption(question.questionID,userAnswers,"rating",ratingAreaDiv,question.questionType,true)

                // }


          } else if (question.questionType === '04' || question.questionType === '11' || question.questionType === '02') {
              // Populate for short text question type
                // Populate for short text question type
                     // Create textarea field div
                     var textareaFieldDiv = document.createElement('div');
                     textareaFieldDiv.style.cursor = 'pointer';
                     textareaFieldDiv.style.display = 'flex';
                     textareaFieldDiv.className = 'textareaField';
                     var textAreaReq =null;
                     if(question.questionRequired){
                      textAreaReq = document.createElement('div');


                      textAreaReq.innerText = "Required";

                      textAreaReq.style.color = "red";
                      textAreaReq.style.fontStyle = "italic";
                     }
                     // Create inner div for styling
                     var innerDiv = document.createElement('div');
                     innerDiv.style.paddingTop = '10px';
                     innerDiv.style.paddingRight = '8px';

                     // Create textarea element
                     var textarea = document.createElement('textarea');
                     textarea.id = 'textInput';
                     textarea.className = 'textInputArea';
                     textarea.setAttribute('question', question.questionID);
                    //  textarea.type = 'text';



                     // Create div for min/max text
                     var minmaxDiv = document.createElement('div');
                     minmaxDiv.className = 'minmaxtext';

                     // Add min text if minLength exists
                     if (question.minLength !=null) {
                      textarea.minLength = question.minLength;
                         var minSpan = document.createElement('span');
                         minSpan.id = question.questionID;
                         minSpan.className = 'survey-text-minlength';
                         minSpan.textContent = '* Min ' + question.minLength + ' characters';
                         minmaxDiv.appendChild(minSpan);
                     }
                     else if(question.validation !=null && question.validation.typeInfo!=null){
                      if(question.validation.typeInfo.length.min){
                        textarea.minLength =question.validation.typeInfo.length.min;
                        var minSpan = document.createElement('span');
                        minSpan.id = question.questionID;
                        minSpan.className = 'survey-text-minlength';
                        minSpan.textContent =question.validation.typeInfo.length.min
                        minmaxDiv.appendChild(minSpan);

                      }
                      if(question.validation.typeInfo.length.max && question.validation.typeInfo.length.max!=null){
                        textarea.maxLength = question.validation.typeInfo.length.max;
                         var maxSpan = document.createElement('span');
                         maxSpan.id = question.questionID;
                         maxSpan.className = 'survey-text-maxlength';
                         maxSpan.innerHTML = '( <span class="setMinCount" id="' + question.questionID + 'count"></span> / ' + question.validation.typeInfo.length.max + ' )';
                         minmaxDiv.appendChild(maxSpan);

                      }
                      if(question.validation.type !=null && question.validation.type=='number'){
                        textarea.type = "number"
                      }

                     }

                     // Add max text if maxLength exists
                     if (question.maxLength!=null) {
                      textarea.maxLength = question.maxLength;
                         var maxSpan = document.createElement('span');
                         maxSpan.id = question.questionID;
                         maxSpan.className = 'survey-text-maxlength';
                         maxSpan.innerHTML = '( <span class="setMinCount" id="' + question.questionID + 'count"></span> / ' + question.maxLength + ' )';
                         minmaxDiv.appendChild(maxSpan);
                     }

                     // Create div for error
                     var errorDiv = document.createElement('div');
                     errorDiv.id = question.questionID + 'shortTextError';
                     errorDiv.className = 'shortTextErr';
                     if(textAreaReq !=null){
                     innerDiv.appendChild(textAreaReq);
                     }

                     innerDiv.appendChild(textarea);
                     innerDiv.appendChild(minmaxDiv);
                     innerDiv.appendChild(errorDiv);

                     textareaFieldDiv.appendChild(innerDiv);
                     container.appendChild(textareaFieldDiv);
                     var userAnswers=null

                      if(question.userQuestionResponse !=null){
                        userAnswers= question.userQuestionResponse.questionTextResponse
                        preMapMultiSelectOption(question.questionID,userAnswers,"question",textareaFieldDiv,question.questionType,false)


                       }
                      //  else if(question.mappedAttributeValue !=null !=null){
                      //   userAnswers = question.mappedAttributeValue
                      //   preMapMultiSelectOption(question.questionID,userAnswers,"question",textareaFieldDiv,question.questionType,true)


                      //  }



                    }
          else if(question.questionType === '13') {
            // Create main div for date picker

            var datePickerDiv = document.createElement('div');
            datePickerDiv.style.display = 'flex';
            datePickerDiv.style.flexDirection = 'column';
            datePickerDiv.className = 'datePicker';
            var datePickerReq = null
            if(question.questionRequired){
              datePickerReq = document.createElement('div');


              datePickerReq.innerText = "Required";

              datePickerReq.style.color = "red";
              datePickerReq.style.fontStyle = "italic";
             }
            // Create div for selected date

            var inputDate = document.createElement('input');
            inputDate.className = 'textInputArea';
            inputDate.type = 'date';
            inputDate.id = 'datePicker_' + question.questionID;
            inputDate.setAttribute('question', question.questionID);
            if(datePickerReq !=null){
             datePickerDiv.appendChild(datePickerReq);
            }
            datePickerDiv.appendChild(inputDate);

            // Create div for error
            var errorDiv = document.createElement('div');
            errorDiv.id = question.questionID + 'multiError';
            datePickerDiv.appendChild(errorDiv);
            let userAnswers= null
            if(question.userQuestionResponse !=null){
              userAnswers= question.userQuestionResponse.questionTextResponse
              preMapMultiSelectOption(question.questionID,userAnswers,"date",datePickerDiv,question.questionType,false)


             }
            //  else if(question.mappedAttributeValue !=null){
            //   userAnswers= question.userQuestionResponse.mappedAttributeValue
            //   preMapMultiSelectOption(question.questionID,userAnswers,"date",datePickerDiv,question.questionType,true)


            //  }

            // Append the date picker div to the container
            container.appendChild(datePickerDiv);
        }


           ratingButtons = jobDetails.querySelectorAll(".rating");
           ratingArea = jobDetails.querySelector(".ratingArea");
          ratingButtons.forEach(function (ratingButton) {
            ratingButton?.addEventListener("click", function () {
              if (this.checked) {
                radioButtonSelect(this.checked,ratingArea,ratingButton)
              }
            });
          });


          datePicker = jobDetails.querySelectorAll(".datePicker");
        datePicker.forEach(function (selectElem) {
          selectElem?.addEventListener("input", event=> {
           datePickerEvent(selectElem,event)


          });
        });

        textInput= jobDetails.querySelectorAll(".textInputArea");
        textInput.forEach(function (textinp) {
          textinp?.addEventListener("input", function () {
            textApplyButton(textinp)
        }
       );
      });
        questionData=[]
        questionElements = jobDetails.querySelectorAll(".question");
        questionData = Array.from(questionElements).map(
          (questionElement) => {
            const [questionID, questionType] = questionElement
              .getAttribute("id")
              .split("_");
            return [questionID, questionType];
          }
        );
        requiredQuestions=[]
        questionRequired =  jobDetails.querySelectorAll(".questionRequired");

        Array.from(questionRequired).map((req) =>{
          let obj={}
          obj['id']=req.getAttribute('id')
          obj['type']=req.getAttribute('type')
          if(req.getAttribute('minLength')&& req.getAttribute('minLength').length>0){
            obj['minlength']=parseInt(req.getAttribute('minLength'))
          }
            requiredQuestions.push(obj)

        }
        );




      });

      singleselect = jobDetails.querySelectorAll(".singleselect");
          singleselect.forEach(function (selectElem) {
            selectElem?.addEventListener("click", event=> {
              var isDuplicate = false;
              singleSelectDropDown(selectElem,event)

                dropDownDisplayStyle(event)


            });
          });

          multiselect = jobDetails.querySelectorAll(".multiselect");
          multiselect.forEach(function (select) {


           select?.addEventListener("click",event=> {

             multiSelectDropDown(select,event);
             dropDownDisplayStyle(event)



           });
         });



}

function preMapMultiSelectOption(questionId,answerList,type,currentElement,questionType,mappedFields){
  if(type=='multiselect'){
    var checkbox=[]
    var options =currentElement.querySelectorAll('.dropdown li')
    var currEle = currentElement.querySelector('.inputBoxMultiSelect')
    currEle.placeholder=''
    options.forEach((item) => {
      // Get the input element within the clicked list item
      checkbox.push(item.querySelector('input[type="checkbox"]'));
  });
    for(var i=0;i<answerList.length;i++){

      for(var j=0;j<checkbox.length;j++){
        var value=checkbox[j].getAttribute("value")
        var label=checkbox[j].getAttribute("id")
        if(answerList[i]==value){
          if(currEle.placeholder.length == 0){
          currEle.placeholder =label
          checkbox[j].checked = true
          }

          else{
            checkbox[j].checked = true
            currEle.placeholder =currEle.placeholder+', '+label

          }

        }

      }
      // checkbox.push(item.querySelector('input[type="checkbox"]'));
      let multiselectOptions={}
      multiselectOptions.questionId =questionId
      multiselectOptions.type = type
      multiselectOptions.value = [answerList[i]]
        selectedAnswerIDs.push(multiselectOptions);

    }
  }
  else if(type =='rating' && questionType !='06'){
    // var selectedDiv = currentElement.querySelector("#selected input[type='text']");
    dropdownDiv.style.display =  'block';
    var options= currentElement.querySelectorAll('.dropdown li')

    var checkbox=[]

    options.forEach((item,index) => {
      // Get the input element within the clicked list item
      let input =item.querySelector('input[type="hidden"]')
      if(answerList[answerList.length-1]==input.getAttribute("value")){

        var placeholder = currentElement.querySelector(".inputBoxSingleSelect")
        item.style.backgroundColor = 'lightgrey';
        var listItems = currentElement.querySelector('dropdown li')
        placeholder.placeholder = input.getAttribute("id")
        let selectedOptionObject ={}
      selectedOptionObject['questionId']=questionId
        selectedOptionObject['value']= [answerList[answerList.length-1]]
        selectedOptionObject['type']='rating'
         selectedOption.push(selectedOptionObject)
      }

  });

  }
  else if(type == 'question'){
    let text ={}
    text['questionId']=questionId
    text['value']= answerList
    text['type']='text'
   text['minlength']=currentElement.getAttribute('minlength')
   text['maxlength']=currentElement.getAttribute('maxlength')
   let curreEle = currentElement.querySelector('.textInputArea')
   let characterCount = currentElement.querySelector('.setMinCount')
   if(characterCount !=null){
   characterCount.textContent = answerList.length
   }
   curreEle.value =answerList

    TextValue.push(text)
  }
  else if(type=='rating' ){
    var ratingArray={}

    let curreEle = currentElement.querySelectorAll('.ratingInput input')
    for(var i=0;i<curreEle.length;i++){
      if(curreEle[i].getAttribute('value')==answerList[answerList.length-1]){
        ratingArray['questionId']=questionId
        ratingArray['value']=[]
        ratingArray['value'].push(answerList[answerList.length-1])
        ratingArray['type']='rating'
        ratingValue.push(ratingArray)
        curreEle[i].checked=true
      }

    }

  }
  else if(type == 'date'){
    var curreEle = currentElement.querySelector(".datePicker")
    var dateInput = currentElement.querySelector(".datePicker input")

    if(currentElement.getAttribute('question')==questionId){
     let dateObject={}
    dateObject['questionId']=questionId
    dateObject['value']=answerList

    dateObject['type']='date'
    DateTime.push(dateObject)
    }
    dateInput.value=answerList

  }

}
const branchedQuestionnaire = jobDetails.querySelector('#branchedQuestionnaire');
if(branchedQuestionnaire){
templateId=branchedQuestionnaire.dataset['questiontemplateid']
hasPreviousButton = branchedQuestionnaire.dataset['haspreviousbutton']
hasNextButton= branchedQuestionnaire.dataset['hasnextbutton']
isBranchedQuestionnaire =true
if(hasPreviousButton=='false'){
  previousButton.classList.add('disable')
}
else{
previousButton.classList.remove('disable')
}

if(hasNextButton=='false'){
  nextButton.classList.add('disable')
}
else{
nextButton.classList.remove('disable')
}

if(hasNextButton=='true'){
  submitForm.classList.add('disable')
}
else{
submitForm.classList.remove('disable')
}
if(hasNextButton != 'true'){
  hasAnsweredAll =true
}

}

if(nextButton){
  const data = document.getElementById("job-data").dataset;
  jobPostingId = data["jobid"];
  jobPostingCompanyId = data["jobPostingCompanyId"]
  nextButton.addEventListener("click",nextButtonMethod)
  async function nextButtonMethod(){

    var spinner = jobDetails.querySelector("#quick-apply-spinner");
    var overlay = jobDetails.querySelector("#quick-apply-overlay");
    var phone = "";

    if(userId==0){
    const firstName = jobDetails.querySelector("#firstName");
    const lastName = jobDetails.querySelector("#lastName");
    const emailInput = jobDetails.querySelector("#emailInput");
    const phoneField = jobDetails.querySelector("#phone");

    phone = phoneInputQuickApply.getNumber();
    let isValidated=true;

    isValidated = validateFieldsQuickApply(
      firstName,
      lastName,
      emailInput,
      phoneField,

    );
    var resp =null
    let ValidatedQuestionnaire =true
    if(questionData.length>0){
      var resp= getAnswerList()
      ValidatedQuestionnaire= ValidateQuestionnaire(questionRequired,resp.userAnswerResponse)

     }

    if(isValidated && ValidatedQuestionnaire){

        const userData = {
          userName: emailInput?.value,
          firstName: firstName?.value,
          lastName: lastName?.value,
          email: emailInput?.value,
          password: "",
          phone: phone,
          phoneNumberValid: true,
          companyCode: companyCode,
          sourceType: "",
          referralUrl: "",
          referralCode: "",
          userDeviceAppTkn: "",
          duplicateCheckRequired: true,
          isEmailSystemGenerated: true,
          completeRegistration: false,
          userAgreement: false,
          marketingEmailFlag: false,
          enabled: true,
          notificationTypeMap: { WHATSAPP: false },
        };
        const formData = new FormData();
        formData.append("user", JSON.stringify(userData));
        if (quickApplyOriginChannel) {
          console.log("Appending originChannel to quick apply preregistration:", quickApplyOriginChannel);
          formData.append("originChannel", quickApplyOriginChannel);
        }
        if (utmTrackerId) {
          formData.append('utmTrackerId', utmTrackerId);
        }

        overlay.style.display = "block";
        spinner.style.display = "block";

        var response = await quickAnonUserRegister(formData, recommendedJobsOptions.enabled);

          if (response.success == true) {
            const apiData1 = document.getElementById("api-data").dataset;

            userId = response.userId
            firstName.readOnly = true;
            firstName.classList.add('readOnly')
            lastName.readOnly = true;
            lastName.classList.add('readOnly')
            emailInput.readOnly=true;
            emailInput.classList.add('readOnly')
            phoneField.readOnly=true;
            phoneField.classList.add('readOnly')

          let  req=createRequestPayload("next",resp.lastQuestionId,templateId,jobPostingId,resp.userAnswerResponse,userId,hasAnsweredAll)

              var response2 =  await branchedQuestionsFetch(req, recommendedJobsOptions.enabled)

              if(response2.questions.length>0){

                createQuestionnaires(response2.questions)
                buttonStatus(response2.hasNextQuestion,response2.hasPreviousQuestion)
              }
              else{
                endofBranchedQuestionnaire()
              }

             } else {
              const errorMessage = response.split(".")[0];

              spinner.style.display = "none";
              overlay.style.display = "none";

              if (!errorMessage) return false;
              showErrorMessage("Submit your Resume", errorMessage);
              const lowerErrorMessage = errorMessage.toLowerCase();
              if (
                lowerErrorMessage.indexOf(
                  "this email address is already in use"
                ) >= 0
              ) {
                jobDetails.querySelector(
                  "#quick-apply-existing-user"
                ).style.display = "block";
                window.scrollTo({ top: 0, behavior: 'smooth' });
                appendLoginUrl()
                oldEmail=emailInput.value
              } else if (
                lowerErrorMessage.indexOf(
                  "you have already applied for this job"
                ) >= 0
              ) {
                jobDetails.querySelector("#alreadyApplied").style.display =
                  "block";
              } else if (lowerErrorMessage.indexOf("email") >= 0) {
                displayValidationMessage(
                  jobDetails.querySelector("#emailInput"),
                  errorMessage
                );
              } else if (lowerErrorMessage.indexOf("phone") >= 0) {
                displayValidationMessage(
                  jobDetails.querySelector("#phone"),
                  errorMessage
                );
              } else if (lowerErrorMessage.indexOf("first name") >= 0) {
                displayValidationMessage(
                  jobDetails.querySelector("#firstName"),
                  errorMessage
                );
              } else if (lowerErrorMessage.indexOf("last name") >= 0) {
                displayValidationMessage(
                  jobDetails.querySelector("#lastName"),
                  errorMessage
                );
              } else if (lowerErrorMessage.indexOf("resume") >= 0) {
                displayValidationMessage(resumeField, response);
              }
            }


             overlay.style.display = "none";
             spinner.style.display = "none";



          }
          }
          else{


            var resp =null
            let validatedQuestionnaire = true;
            if(questionData.length>0){
              var resp= getAnswerList()
              validatedQuestionnaire=  ValidateQuestionnaire(questionRequired,resp.userAnswerResponse)

             }
             if(validatedQuestionnaire){
              overlay.style.display = "block";
              spinner.style.display = "block";
            let  req=createRequestPayload("next",resp.lastQuestionId,templateId,jobPostingId,resp.userAnswerResponse,userId,hasAnsweredAll)

            var response2 =  await branchedQuestionsFetch(req, recommendedJobsOptions.enabled)
            if(response2.questions.length>0){

              createQuestionnaires(response2.questions)
              hasNextButton = response2.hasNextQuestion
              hasPreviousButton = response2.hasPreviousButton
              buttonStatus(response2.hasNextQuestion,response2.hasPreviousQuestion)

              if(!hasNextButton ){
                hasAnsweredAll = true
              }
              isCurrentQuestionnairePageAnswered=false;
            }
            else{

              endofBranchedQuestionnaire()
            }
            overlay.style.display = "none";
            spinner.style.display = "none";
          }

          }

  }
}

if(previousButton){
    previousButton.addEventListener("click",previousButtonMethod)
    async function previousButtonMethod(){
      var spinner = jobDetails.querySelector("#quick-apply-spinner");
      var overlay = jobDetails.querySelector("#quick-apply-overlay");
      const data = document.getElementById("job-data").dataset;
      var spinner = jobDetails.querySelector("#quick-apply-spinner");
      var overlay = jobDetails.querySelector("#quick-apply-overlay");
      var phone = "";


              var resp= getAnswerList()

              // no validation required for back button
              // let validatedQuestionnaire =false;
              // if(questionData.length>0){
              //   validatedQuestionnaire= ValidateQuestionnaire(questionRequired,resp.userAnswerResponse)

              //  }

              overlay.style.display = "block";
              spinner.style.display = "block";
              let  req=createRequestPayload("previous",resp.lastQuestionId,templateId,jobPostingId,resp.userAnswerResponse,userId,hasAnsweredAll)

              var response2 =  await branchedQuestionsFetch(req, recommendedJobsOptions.enabled)
              if(response2.questions.length>0){

                createQuestionnaires(response2.questions)
                hasNextButton = response2.hasNextQuestion
                hasPreviousButton = response2.hasPreviousButton
                buttonStatus(response2.hasNextQuestion,response2.hasPreviousQuestion)

                if(!hasNextButton ){
                  hasAnsweredAll = true
                }
                isCurrentQuestionnairePageAnswered=false;
              }
              overlay.style.display = "none";
              spinner.style.display = "none";


            }

    }

    function endofBranchedQuestionnaire(){
      var errordiv = jobDetails.querySelector('#noNextQuestionError')
      let  errorMessage = document.createElement('p');

      if (errordiv) {
        errorMessage.className = 'error-message';
        errorMessage.style.color = 'red';
        errorMessage.style.fontSize = '12px';
        errorMessage.style.marginTop = '6px';
        errordiv.appendChild(errorMessage);
      }
      errorMessage.innerHTML = __t['quickApply.endQuestionnaireMessage'];
      errorMessage.style.display='block'
      setTimeout(() => {
       errorMessage.style.display = 'none';
    }, 6000);
    nextButton.classList.add('disable')

submitForm.classList.remove('disable')
isAtBranchEnd = true;
    }

        function ValidateQuestionnaire(questionRequired,questionResponseDataArray){
          for(var i=0;i<requiredQuestions.length;i++){
            for(var j=0;j<questionResponseDataArray.length;j++){
              if(questionResponseDataArray[j].questionID==requiredQuestions[i]['id']){
                let answerArray= questionResponseDataArray[j].userQuestionResponse
                let requiredArray= requiredQuestions[i]
                if(requiredArray['type']=='01' && (typeof answerArray.userAnswerList == 'undefined' || answerArray.userAnswerList.length==0) ){
                  displayErrorMessage(questionResponseDataArray[j].questionID+"multiError", __t['quickApply.multiselectErrorRequired']);
                  return false
                }
                else if((requiredArray['type']=='03' || requiredArray['type']=='12') && (typeof answerArray.userAnswerList == 'undefined' || answerArray.userAnswerList== null || answerArray.userAnswerList.length==0)){
                  displayErrorMessage(questionResponseDataArray[j].questionID+"singleError", __t['quickApply.singleSelectErrorRequired']);
                  return false
                }
                else if(requiredArray['type']=='06' && (typeof answerArray.userAnswerList == 'undefined' || answerArray.userAnswerList== null || answerArray.userAnswerList.length==0)){
                  displayErrorMessage(questionResponseDataArray[j].questionID+"ratingError", __t['quickApply.ratingErrorRequired']);
                  return false

                }

                else if((requiredArray['type']=='04'||requiredArray['type']=='11' || requiredArray['type']=='02') &&
                (typeof answerArray.questionTextResponse == 'undefined' || answerArray.questionTextResponse.length==0 ||(typeof requiredArray.minlength!='undefined' && answerArray.questionTextResponse.length>=requiredArray.minlength)) ){
                  displayErrorMessage(questionResponseDataArray[j].questionID+"shortTextError", __t['quickApply.textInputErrorInvalid']);
                  return false

                }
              }


            }
          }
          return true
        }
        function validateFields(
          firstName,
          lastName,
          emailInput,
          termsField,
          termsField2,
          termsField3,
          phoneField,
          resumeField,
          file
        ) {
          if(companyData["resumetypesallowed"]){
            var allowedTypes = companyData["resumetypesallowed"].split(",");
            }

            firstName.setCustomValidity("");
            lastName.setCustomValidity("");
            phoneField.setCustomValidity("");
            if (file) {
              resumeField.setCustomValidity("");
            }
            if (!(firstName?.value?.length > 0)) {
              setTimeout(() => {
                displayValidationMessage(
                  firstName,
                  __t['global.firstNameErrorRequired']
                );
              }, 500);
              return false;
            }

            if (!(lastName?.value?.length > 0)) {
              setTimeout(() => {
                displayValidationMessage(lastName, __t['global.lastNameErrorRequired']);
              }, 500);
              return false;
            }

            if (
              !(emailInput?.value?.length > 0 && validateEmail(emailInput?.value))
            ) {
                displayValidationMessage(
                  emailInput,
                  emailInput?.value?.length
                    ? __t['global.emailErrorInvalid']
                    : __t['global.emailErrorRequired'],
                    'inputValidation'
                );
              return false;
            }

            if (
              !(
                phoneField?.value?.length > 0 &&
                phoneInputQuickApply.isValidNumber()
              )
            ) {
                displayValidationMessage(
                  phoneField,
                  phoneField?.value?.length
                    ? __t['quickApply.phoneErrorInvalid']
                    : __t['quickApply.phoneErrorRequired'],
                    'inputValidation'
                );
              return false;
            }

            if (companyData["resumeuploadrequired"] === "01") {
              if (resumeField.files.length > 0) {
                if (!allowedTypes.includes(resumeField.files[0].type)) {
                  setTimeout(() => {
                    displayValidationMessage(
                      resumeField,
                      __t['quickApply.resumeErrorInvalid']
                    );
                  }, 500);
                  return false;
                }
              } else {
                setTimeout(() => {
                  displayValidationMessage(
                    resumeField,
                    __t['quickApply.resumeSubmit'],
                    __t['quickApply.resumeErrorRequired']
                  );
                }, 500);
                displayValidationMessage(resumeField, __t['quickApply.resumeErrorRequired']);
                return false;
              }
            } else if (
              companyData["resumeuploadrequired"] === "02" &&
              resumeField.files.length > 0
            ) {
              if (!allowedTypes.includes(resumeField.files[0].type)) {
                setTimeout(() => {
                  displayValidationMessage(
                    resumeField,
                    __t['quickApply.resumeErrorInvalid']
                  );
                }, 500);
                return false;
              }
            }

            if (companyData["termsandservices"] == "true") {
              termsField.setCustomValidity("");
              if (!termsField.checked) {
                setTimeout(() => {
                  displayValidationMessage(
                    termsField,
                    __t['quickApply.termsRequired']
                  );
                }, 500);
                return false;
              }
              if ( termsField2 && !termsField2.checked) {
                termsField2.setCustomValidity("");
                setTimeout(() => {
                  displayValidationMessage(
                    termsField2,
                    __t['quickApply.termsRequired']
                  );
                }, 500);
                return false;
              }
              if ( termsField3 && !termsField3.checked) {
                termsField3.setCustomValidity("");
                setTimeout(() => {
                  displayValidationMessage(
                    termsField3,
                    __t['quickApply.termsRequired']
                  );
                }, 500);
                return false;
              }
            }
            if (companyData["recaptcharequired"] == "true") {
              if (
                !(window.grecaptcha && window.grecaptcha.getResponse().length !== 0) &&
                captchaErrorMessage
              ) {
                captchaErrorMessage.style.display = "block";
                return false;
              }
            }

            return true;
        }

        function getAnswerList(){
          var questionResponseDataArray = [];

            questionData.forEach((data) => {
              const questionID = data[0];
              const questionType = data[1];

              if (
                questionType === "06") {
                var answerList= fetchAnswer(ratingValue,questionID,questionType)
                const questionObject1 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: answerList,
                    questionTextResponse: "",
                  },
                };
                questionResponseDataArray.push(questionObject1);
              } else if (
                questionType === "01"
              ) {
               var answerList= fetchAnswer(selectedAnswerIDs,questionID,questionType)
                const questionObject2 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: answerList,
                    questionTextResponse: "",
                  },
                };
                questionResponseDataArray.push(questionObject2);
              } else if (
                questionType === "03" ||  questionType === "12"
              ) {
                var answerList= fetchAnswer(selectedOption,questionID,questionType)
                const questionObject3 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: answerList,
                    questionTextResponse: "",
                  },
                };
                questionResponseDataArray.push(questionObject3);
              } else if (
                questionType === "04" ||
                questionType === "02" ||
                (questionType === "11")
              ) {
                var answerList= fetchAnswer(TextValue,questionID, questionType)
                const questionObject4 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: [],
                    questionTextResponse: answerList,
                  },
                };
                questionResponseDataArray.push(questionObject4);
              }
              else if(questionType =='13'){
                var answerList= fetchAnswer(DateTime,questionID, questionType)
                const obj5={
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: [],
                    questionTextResponse: answerList,
                  },
                }
                questionResponseDataArray.push(obj5);
              }
            });
            return {"userAnswerResponse":questionResponseDataArray,"lastQuestionId": questionData}
        }
        function validateFieldsQuickApply(  firstName,
          lastName,
          emailInput,
          phoneField,){
            firstName.setCustomValidity("");
          lastName.setCustomValidity("");
          phoneField.setCustomValidity("");


          if (!(firstName?.value?.length > 0)) {
            setTimeout(() => {
              displayValidationMessage(
                firstName,
                __t['global.firstNameErrorRequired']
              );
            }, 500);
            return false;
          }

          if (!(lastName?.value?.length > 0)) {
            setTimeout(() => {
              displayValidationMessage(lastName, __t['global.lastNameErrorRequired']);
            }, 500);
            return false;
          }

          if (
            !(emailInput?.value?.length > 0 && validateEmail(emailInput?.value))
          ) {
              displayValidationMessage(
                emailInput,
                emailInput?.value?.length
                  ? __t['global.emailErrorInvalid']
                  : __t['global.emailErrorRequired'],
                  'inputValidation'
              );
            return false;
          }

          if (
            !(
              phoneField?.value?.length > 0 &&
              phoneInputQuickApply.isValidNumber()
            )
          ) {
              displayValidationMessage(
                phoneField,
                phoneField?.value?.length
                  ? __t['quickApply.phoneErrorInvalid']
                  : __t['quickApply.phoneErrorRequired'],
                  'inputValidation'
              );
            return false;
          }
          return true
        }
        function buttonStatus(hasNextQuestion,hasPreviousQuestion){

          if(!hasNextQuestion){
            submitForm.classList.remove('disable')
            nextButton.classList.add('disable')
          }
          else{
            submitForm.classList.add('disable')
            nextButton.classList.remove('disable')

          }
          if(!hasPreviousQuestion){
            previousButton.classList.add('disable')
          }
          else{
            previousButton.classList.remove('disable')

          }
        }
        function createRequestPayload(navigation,lastQuestionId,templateId,jobId,userResponse,userId,hasAnsweredAll){
          var lastId=0
             if(navigation=='next'){
               lastId= lastQuestionId[lastQuestionId.length-1][0]
            }
            else if(navigation=='previous'){
             lastId= lastQuestionId[0][0]

            }

          return  {
            "navigation":navigation,
            "currentQuestionId":parseInt(lastId),
            "companyCode":jobPostingCompanyId,
            "questionnaireInfo":{
            "questionTemplateId":parseInt(templateId),
            "jobPostingId":parseInt(jobId),
            "questionResponseData":userResponse,
            "referralCode":"",
            "userId":userId
          },
            "hasAnsweredAll":hasAnsweredAll

          }
        }

        function displayValidationMessage(field, message, inputValidation) {
          try {
            if(inputValidation){
              field.focus();
            }
            setTimeout(() => {
              field.setCustomValidity(message || __t['global.requiredField']);
              field.reportValidity();
            }, 2000);
          } catch (err) {
            console.log(err);
          }
        }

        function showSuccessMessage(title, message) {
          showMessage(title, message, "success");
        }
        function showWarningMessage(title, message) {
          showMessage(title, message, "warning");
        }
        function showErrorMessage(title, message) {
          showMessage(title, message, "error");
        }
        function showMessage(title, message, type) {
          console.log(type, title, message);
        }
        function fetchAnswer(answerArray,questionId,questionType){
          if(answerArray.length>0){
            for(var i=0; i<answerArray.length;i++){
              if(questionId==answerArray[i]['questionId']){

                return answerArray[i]['value']
              }

            }
             if(questionType=='01'|| questionType=='06'|| questionType=='03' || questionType=='12'){
              return []
            }
            else{
              return null
            }
          }
          else if(questionType=='01'|| questionType=='06'|| questionType=='03' || questionType=='12'){
            return []
          }
          else{
            return ""
          }
        }
      }
    },
  };
};
